// import React, { useState, useEffect } from 'react';
// import { database, ref, get, set, update, query, orderByChild, equalTo, onValue } from '../../firebase';
// import { Wallet, Users, TrendingUp, Gift,AlertCircle, Check, Battery, X, Package, Info, Search, Shield, AlertTriangle, DollarSign, History, Clock, ArrowUpRight, Calendar, CreditCard } from 'lucide-react';
// import { saveScratchHistory, fetchScratchMinRewards } from '../../utils/scratchCardService';

// const DEFAULT_ACTIVATION_BONUS_RULE = {
//   enabled: true,
//   requiredPackages: 3,
//   windowDays: 45,
//   bonusAmount: 15,
//   wallet: 'working'
// };

// const ActivatePackage = () => {
//   const [selectedWallet, setSelectedWallet] = useState('aurum');
//   const [selectedPackage, setSelectedPackage] = useState('');
//   const [amount, setAmount] = useState('');
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // User info
//   const [userId, setUserId] = useState('');
//   const [userName, setUserName] = useState('');
//   const [userSponsorId, setUserSponsorId] = useState('');
//   const [userDbKey, setUserDbKey] = useState('');
//   const [userRegistrationDate, setUserRegistrationDate] = useState('');
//   const [userUplineId, setUserUplineId] = useState('');
  
//   // Get user's active package for commission calculation
//   const [userActivePackage, setUserActivePackage] = useState(null);
  
//   // Wallet balances
//   const [walletBalances, setWalletBalances] = useState({
//     aurum: 0,
//     fund: 0
//   });
//   const [activationBonusRule, setActivationBonusRule] = useState(DEFAULT_ACTIVATION_BONUS_RULE);
//   const [activationRuleLoaded, setActivationRuleLoaded] = useState(false);

//   // NEW: Fund Wallet Transactions
//   const [fundTransactions, setFundTransactions] = useState([]);
//   const [loadingTransactions, setLoadingTransactions] = useState(false);
//   const [showFundHistory, setShowFundHistory] = useState(false);
//   const [fundStats, setFundStats] = useState({
//     totalAdded: 0,
//     totalPending: 0,
//     count: 0,
//     pendingCount: 0
//   });

//   // For buying for downline
//   const [isBuyingForDownline, setIsBuyingForDownline] = useState(false);
//   const [selectedDownline, setSelectedDownline] = useState('');
//   const [selectedDownlineName, setSelectedDownlineName] = useState('');
//   const [downlineList, setDownlineList] = useState([]);
//   const [showDownlineSearch, setShowDownlineSearch] = useState(false);
//   const [searchDownlineId, setSearchDownlineId] = useState('');

//   // Dialog states
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
//   const [confirmData, setConfirmData] = useState(null);
//   const [showErrorDialog, setShowErrorDialog] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
  
//   // New state for purchase status
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [showSuccessNotification, setShowSuccessNotification] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [showScratchDialog, setShowScratchDialog] = useState(false);
//   const [scratchRewardAmount, setScratchRewardAmount] = useState(0);
//   const [scratchReferenceId, setScratchReferenceId] = useState('');
//   const [scratchLoading, setScratchLoading] = useState(false);
//   const [packageScratchMinReward, setPackageScratchMinReward] = useState(2);
//   const PACKAGE_SCRATCH_MIN_REWARD = packageScratchMinReward;

//   // Block status listeners
//   const [blockStatusListeners, setBlockStatusListeners] = useState([]);
  
//   // Store current user's block status
//   const [currentUserBlockStatus, setCurrentUserBlockStatus] = useState({
//     downlineActivationStatus: 'enabled',
//     loginStatus: 'active',
//     isBlocked: false
//   });

//   useEffect(() => {
//     const storedUserId = localStorage.getItem('userId');
//     const storedUserName = localStorage.getItem('userName');
//     const storedSponsorId = localStorage.getItem('userSponsorId') || storedUserId;
//     const storedDbKey = localStorage.getItem('dbKey');
//     const storedUplineId = localStorage.getItem('userUplineId');
//     const storedRegistrationDate = localStorage.getItem('registrationDate');

//     if (storedUserId) {
//       setUserId(storedUserId);
//       setUserSponsorId(storedSponsorId);
//       setUserDbKey(storedDbKey || storedUserId);
//       setUserRegistrationDate(storedRegistrationDate || '2026-02-06'); // Default date
//       setUserUplineId(storedUplineId || '');
//       fetchUserBalances(storedDbKey || storedUserId, storedRegistrationDate);
//       fetchUserActivePackage(storedDbKey || storedUserId, storedRegistrationDate);
      
//       // NEW: Fetch fund wallet transactions
//       fetchFundWalletTransactions(storedUserId, storedDbKey);
      
//       // Start listening for block status changes
//       setupBlockStatusListeners(storedDbKey || storedUserId, storedRegistrationDate);
//     }
//     if (storedUserName) setUserName(storedUserName);

//     fetchPackages();
//     fetchActivationBonusRule();
//     fetchScratchSettings();

//     // Cleanup listeners on unmount
//     return () => {
//       blockStatusListeners.forEach(unsubscribe => unsubscribe());
//     };
//   }, []);

//   const fetchScratchSettings = async () => {
//     try {
//       const settings = await fetchScratchMinRewards();
//       setPackageScratchMinReward(Number(settings.package_activation) || 2);
//     } catch (error) {
//       console.error('Error fetching package scratch minimum settings:', error);
//     }
//   };

//   // NEW: Fetch Fund Wallet Transactions from UserFundTransactions
//   const fetchFundWalletTransactions = async (userId, dbKey) => {
//     setLoadingTransactions(true);
//     try {
//       const txRef = ref(database, 'UserFundTransactions');
//       const snapshot = await get(txRef);
      
//       const transactionsList = [];
//       let totalAdded = 0;
//       let totalPending = 0;
//       let count = 0;
//       let pendingCount = 0;
      
//       if (snapshot.exists()) {
//         const data = snapshot.val();
        
//         // Search through all dates
//         Object.entries(data).forEach(([date, dateGroup]) => {
//           Object.entries(dateGroup).forEach(([userKey, userGroup]) => {
//             Object.entries(userGroup).forEach(([txId, tx]) => {
//               // Check if this transaction belongs to current user
//               if (tx.userId === userId || tx.memberId === dbKey || userKey === dbKey) {
//                 const isCompleted = tx.status === 'completed' || tx.status === 'success';
                
//                 const transaction = {
//                   id: txId,
//                   date: date,
//                   amount: parseFloat(tx.amount) || 0,
//                   previousBalance: parseFloat(tx.previousFundBalance) || 0,
//                   newBalance: parseFloat(tx.fundBalance) || 0,
//                   paymentMethod: tx.displayCurrency || tx.currency || 'Crypto',
//                   status: tx.status || 'pending',
//                   timestamp: tx.timestampFormatted || tx.timestamp || date,
//                   description: tx.reason || tx.description || 'Fund Addition',
//                   source: tx.source || 'User',
//                   network: tx.network || '',
//                   currency: tx.currency || '',
//                   transactionId: tx.transactionId || txId,
//                   isCompleted: isCompleted
//                 };
                
//                 transactionsList.push(transaction);
                
//                 // Only count completed transactions in totals
//                 if (isCompleted) {
//                   totalAdded += transaction.amount;
//                   count++;
//                 } else {
//                   totalPending += transaction.amount;
//                   pendingCount++;
//                 }
//               }
//             });
//           });
//         });
//       }
      
//       // Sort by date (newest first)
//       transactionsList.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      
//       setFundTransactions(transactionsList);
//       setFundStats({
//         totalAdded,
//         totalPending,
//         count,
//         pendingCount
//       });
      
//     } catch (error) {
//       console.error('Error fetching fund wallet transactions:', error);
//     } finally {
//       setLoadingTransactions(false);
//     }
//   };

//   // Setup real-time listeners for block status
//   const setupBlockStatusListeners = (dbKey, registrationDate) => {
//     const listeners = [];
    
//     // Listen to user's main block statuses
//     const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
//     const userListener = onValue(userRef, (snapshot) => {
//       if (snapshot.exists()) {
//         const userData = snapshot.val();
        
//         // Update current user block status
//         setCurrentUserBlockStatus({
//           downlineActivationStatus: userData.downlineActivationStatus || 'enabled',
//           loginStatus: userData.loginStatus || 'active',
//           isBlocked: userData.downlineActivationStatus === 'disabled' || 
//                     userData.loginStatus === 'blocked'
//         });
        
//         console.log('User status updated:', {
//           loginStatus: userData.loginStatus,
//           roiStatus: userData.roiStatus,
//           levelIncomeStatus: userData.levelIncomeStatus,
//           withdrawalStatus: userData.withdrawalStatus,
//           downlineActivationStatus: userData.downlineActivationStatus,
//           internalTransferStatus: userData.internalTransferStatus
//         });
//       }
//     });
//     listeners.push(userListener);
    
//     setBlockStatusListeners(listeners);
//   };

//   const showError = (message) => {
//     setErrorMessage(message);
//     setShowErrorDialog(true);
//   };

//   const showSuccess = (message) => {
//     setSuccessMessage(message);
//     setShowSuccessNotification(true);
//     setTimeout(() => {
//       setShowSuccessNotification(false);
//     }, 5000);
//   };

//   const generateScratchReward = () => {
//     return PACKAGE_SCRATCH_MIN_REWARD;
//   };

//   const creditPackageScratchToFund = async (rewardAmount, referenceId) => {
//     try {
//       const normalizedReward = Number(rewardAmount);
//       if (!normalizedReward || normalizedReward <= 0) {
//         return { success: false, error: 'Invalid scratch reward amount' };
//       }

//       if (!userRegistrationDate || !userDbKey) {
//         return { success: false, error: 'User session not ready' };
//       }

//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const userSnapshot = await get(userRef);
//       if (!userSnapshot.exists()) {
//         return { success: false, error: 'User not found' };
//       }

//       const userData = userSnapshot.val() || {};
//       const currentFund = userData.fund || {};
//       const currentFundBalance = parseFloat(currentFund.balance) || 0;
//       const currentFundTotal = parseFloat(currentFund.total) || 0;
//       const currentFundCount = parseInt(currentFund.count, 10) || 0;

//       const safeReference = String(referenceId || Date.now()).replace(/[^a-zA-Z0-9_-]/g, '_');
//       const dateKey = new Date().toISOString().split('T')[0];
//       const sponsorKey = userSponsorId || userId || 'unknown';
//       const transactionId = `SCRATCH_PACKAGE_${safeReference}`;
//       const txRef = ref(database, `UserFundTransactions/${dateKey}/${sponsorKey}/${transactionId}`);
//       const existingTx = await get(txRef);
//       if (existingTx.exists()) {
//         return {
//           success: true,
//           alreadyCredited: true,
//           rewardAmount: Number(existingTx.val()?.amount || normalizedReward)
//         };
//       }

//       const newFundBalance = currentFundBalance + normalizedReward;
//       const newFundTotal = currentFundTotal + normalizedReward;
//       const newFundCount = currentFundCount + 1;

//       await update(userRef, {
//         'fund/balance': newFundBalance,
//         'fund/total': newFundTotal,
//         'fund/count': newFundCount,
//         'fund/lastAmount': normalizedReward,
//         'fund/lastDate': new Date().toISOString(),
//         'fund/lastTransactionId': transactionId,
//         'fund/lastTransactionType': 'Scratch Reward',
//         'fund/lastTransactionWallet': 'Fund Wallet',
//         'fund/lastTransactionSource': 'Scratch Card'
//       });

//       await set(txRef, {
//         transactionId,
//         timestamp: Date.now(),
//         timestampFormatted: new Date().toISOString(),
//         userId,
//         userName,
//         memberId: userDbKey,
//         sponsorId: sponsorKey,
//         amount: normalizedReward,
//         type: 'scratch_reward',
//         source: 'Scratch Card',
//         description: 'Package activation scratch reward',
//         wallet: 'Fund Wallet',
//         previousFundBalance: currentFundBalance,
//         fundBalance: newFundBalance,
//         userAddedFund: newFundTotal,
//         fundCount: newFundCount,
//         status: 'completed',
//         referenceId: referenceId || '',
//         minimumReward: PACKAGE_SCRATCH_MIN_REWARD
//       });

//       try {
//         await saveScratchHistory({
//           dateKey,
//           userId,
//           userName,
//           memberId: userDbKey,
//           sponsorId: sponsorKey,
//           amount: normalizedReward,
//           source: 'Scratch Card',
//           eventType: 'package_activation',
//           description: 'Package activation scratch reward',
//           wallet: 'Fund Wallet',
//           referenceId: referenceId || '',
//           minimumReward: PACKAGE_SCRATCH_MIN_REWARD,
//           status: 'completed'
//         });
//       } catch (scratchHistoryError) {
//         console.error('Error saving package scratch history:', scratchHistoryError);
//       }

//       localStorage.setItem('userBalance', String(newFundBalance));
//       setWalletBalances(prev => ({ ...prev, fund: newFundBalance }));
//       await fetchFundWalletTransactions(userId, userDbKey);

//       return { success: true, rewardAmount: normalizedReward };
//     } catch (error) {
//       console.error('Error crediting package scratch reward:', error);
//       return { success: false, error: error.message };
//     }
//   };

//   const handlePackageScratchClaim = async () => {
//     if (scratchLoading || !scratchRewardAmount) return;
//     setScratchLoading(true);
//     try {
//       const result = await creditPackageScratchToFund(scratchRewardAmount, scratchReferenceId);
//       if (result.success) {
//         const creditedAmount = Number(result.rewardAmount || scratchRewardAmount);
//         setShowScratchDialog(false);
//         showSuccess(`Scratch reward claimed: $${creditedAmount.toFixed(2)} added to AV PAY wallet.`);
//       } else {
//         showError(result.error || 'Unable to claim scratch reward.');
//       }
//     } finally {
//       setScratchLoading(false);
//     }
//   };

//   // Fetch user balances with date-wise structure
//   const fetchUserBalances = async (dbKey, registrationDate) => {
//     try {
//       const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
//       const snapshot = await get(userRef);

//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         setWalletBalances({
//           aurum: parseFloat(userData.wallets?.aurum) || 0,
//           fund: parseFloat(userData.fund?.balance) || 0
//         });
//         if (!userUplineId && userData.uplineSponsorId) {
//           setUserUplineId(userData.uplineSponsorId);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching balances:', error);
//     }
//   };

//   // Get user's active package for commission calculation with date-wise structure
//   const fetchUserActivePackage = async (dbKey, registrationDate) => {
//     try {
//       const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
//       const snapshot = await get(userRef);

//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         const userPackages = userData.packages || [];
        
//         const activePackage = userPackages
//           .filter(pkg => pkg.status === 'active')
//           .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))[0];
        
//         setUserActivePackage(activePackage);
//       }
//     } catch (error) {
//       console.error('Error fetching user active package:', error);
//     }
//   };

//   const fetchPackages = async () => {
//     try {
//       const packagesRef = ref(database, 'Packages');
//       const snapshot = await get(packagesRef);
      
//       if (snapshot.exists()) {
//         const packagesData = snapshot.val();
//         const packagesArray = Object.entries(packagesData).map(([id, pkg]) => ({
//           id,
//           ...pkg,
//           roiCreditDays: pkg.roiCreditDays || 5,
//           workingDays: pkg.workingDays || 'Mon-Fri',
//           durationDays: pkg.durationDays || 365,
//           referralLevels: pkg.referralLevels || [0, 0, 0, 0, 0],
//           energyWallet: pkg.energyWallet || 4,
//         }));
//         setPackages(packagesArray);
//       }
//     } catch (error) {
//       console.error('Error fetching packages:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const recordWorkingWalletBonus = async ({
//     targetUser,
//     bonusAmount,
//     previousBalance,
//     newBalance,
//     transactionId,
//     description
//   }) => {
//     try {
//       const dateKey = new Date().toISOString().split('T')[0];
//       const sponsorKey = targetUser.sponsorId || targetUser.userId || 'unknown';
//       const txRef = ref(database, `adminaddedhistory/${dateKey}/${sponsorKey}/${transactionId}`);
//       await set(txRef, {
//         transactionId,
//         userId: targetUser.userId,
//         memberId: targetUser.dbKey,
//         sponsorId: targetUser.sponsorId || targetUser.userId,
//         walletType: 'AV Power Wallet',
//         transactionType: 'AV Power Wallet Credit',
//         amount: bonusAmount,
//         previousBalance,
//         newBalance,
//         description,
//         date: new Date().toISOString(),
//         source: 'Aerovolt'
//       });
//     } catch (error) {
//       console.error('Error recording working wallet bonus:', error);
//     }
//   };

//   const fetchActivationBonusRule = async () => {
//     try {
//       const ruleRef = ref(database, 'Packages/packageRules');
//       const snapshot = await get(ruleRef);
//       if (snapshot.exists()) {
//         const data = snapshot.val() || {};
//         setActivationBonusRule({
//           enabled: data.enabled !== false,
//           requiredPackages: parseInt(data.requiredPackages, 10) || DEFAULT_ACTIVATION_BONUS_RULE.requiredPackages,
//           windowDays: parseInt(data.windowDays, 10) || DEFAULT_ACTIVATION_BONUS_RULE.windowDays,
//           bonusAmount: parseFloat(data.bonusAmount) || DEFAULT_ACTIVATION_BONUS_RULE.bonusAmount,
//           wallet: data.wallet || DEFAULT_ACTIVATION_BONUS_RULE.wallet
//         });
//       } else {
//         setActivationBonusRule(DEFAULT_ACTIVATION_BONUS_RULE);
//       }
//     } catch (error) {
//       console.error('Error fetching activation bonus rule:', error);
//       setActivationBonusRule(DEFAULT_ACTIVATION_BONUS_RULE);
//     } finally {
//       setActivationRuleLoaded(true);
//     }
//   };

//   // Get ALL downlines (up to 10 levels) with date-wise structure
//   const fetchAllDownlines = async () => {
//     try {
//       const usersRef = ref(database, 'users');
//       const snapshot = await get(usersRef);
      
//       if (snapshot.exists()) {
//         const usersByDate = snapshot.val();
//         const allDownlines = [];
        
//         // Function to recursively find downlines with date-wise structure
//         const findDownlines = async (currentSponsorId, level = 1, maxLevel = 10) => {
//           if (level > maxLevel) return;
          
//           // Search through all date folders
//           for (const date in usersByDate) {
//             const users = usersByDate[date];
            
//             for (const [key, user] of Object.entries(users)) {
//               if (user.uplineSponsorId === currentSponsorId) {
//                 // Get complete block status for this user
//                 const blockStatus = await getCompleteBlockStatus(user.sponsorId || key, date, key);
                
//                 allDownlines.push({
//                   dbKey: key,
//                   userId: user.sponsorId || key,
//                   name: user.name || 'Unknown',
//                   sponsorId: user.sponsorId,
//                   uplineSponsorId: user.uplineSponsorId || '',
//                   registrationDate: date,
//                   level: level,
//                   levelLabel: level === 1 ? 'Direct' : `Level ${level}`,
//                   // Complete block status
//                   ...blockStatus
//                 });
                
//                 // Recursively find downlines of this downline
//                 await findDownlines(user.sponsorId, level + 1, maxLevel);
//               }
//             }
//           }
//         };
        
//         // Start from current user's sponsor ID
//         await findDownlines(userSponsorId, 1, 10);
        
//         setDownlineList(allDownlines);
//         console.log(`Found ${allDownlines.length} downlines up to 10 levels`);
//       }
//     } catch (error) {
//       console.error('Error fetching all downlines:', error);
//     }
//   };

//   // COMPLETE BLOCK STATUS CHECK - Checks ALL block locations
//   const getCompleteBlockStatus = async (userId, registrationDate, dbKey) => {
//     try {
//       const status = {
//         // User-level blocks
//         loginStatus: 'active',
//         roiStatus: 'active',
//         levelIncomeStatus: 'active',
//         withdrawalStatus: 'enabled',
//         downlineActivationStatus: 'enabled',
//         internalTransferStatus: 'enabled',
        
//         // Package-level ROI block
//         packageRoiStatus: 'active',
        
//         // Level income collection block
//         levelIncomeCollectionBlocked: false,
        
//         // ROISchedule block
//         roiScheduleBlocked: false,
        
//         // Overall status
//         isBlocked: false,
//         isLevelIncomeBlocked: false,
//         canReceivePackage: true, // Default true
//         blockReasons: []
//       };

//       // 1. Check user-level statuses
//       if (dbKey && registrationDate) {
//         const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
//         const userSnap = await get(userRef);
        
//         if (userSnap.exists()) {
//           const userData = userSnap.val();
          
//           // Get user statuses with defaults
//           status.loginStatus = userData.loginStatus || 'active';
//           status.roiStatus = userData.roiStatus || 'active';
//           status.levelIncomeStatus = userData.levelIncomeStatus || 'active';
//           status.withdrawalStatus = userData.withdrawalStatus || 'enabled';
//           status.downlineActivationStatus = userData.downlineActivationStatus || 'enabled';
//           status.internalTransferStatus = userData.internalTransferStatus || 'enabled';
          
//           // Check if user can receive package
//           // CRITICAL: User cannot receive package if login is blocked
//           if (status.loginStatus === 'blocked') {
//             status.isBlocked = true;
//             status.canReceivePackage = false;
//             status.blockReasons.push('Login blocked - cannot receive packages');
//           }
          
//           // User cannot receive package if downline activation is disabled (for admin blocks)
//           if (status.downlineActivationStatus === 'disabled') {
//             status.isBlocked = true;
//             status.canReceivePackage = false;
//             status.blockReasons.push('Downline activation blocked - cannot receive packages');
//           }
          
//           // Check other blocks for informational purposes
//           if (status.roiStatus === 'blocked') {
//             status.isBlocked = true;
//             status.blockReasons.push('ROI blocked at user level');
//           }
//           if (status.levelIncomeStatus === 'blocked') {
//             status.isLevelIncomeBlocked = true;
//             status.blockReasons.push('Level income blocked at user level');
//           }
//         }
//       }

//       return status;
      
//     } catch (error) {
//       console.error('Error getting complete block status:', error);
//       return {
//         loginStatus: 'active',
//         roiStatus: 'active',
//         levelIncomeStatus: 'active',
//         withdrawalStatus: 'enabled',
//         downlineActivationStatus: 'enabled',
//         internalTransferStatus: 'enabled',
//         packageRoiStatus: 'active',
//         levelIncomeCollectionBlocked: false,
//         roiScheduleBlocked: false,
//         isBlocked: false,
//         canReceivePackage: true,
//         isLevelIncomeBlocked: false,
//         blockReasons: ['Error checking status']
//       };
//     }
//   };

//   // Check if user can purchase (buyer check)
//   const canUserPurchase = async (userId, isForDownline = false) => {
//     try {
//       // Find user first
//       const usersRef = ref(database, 'users');
//       const snapshot = await get(usersRef);
      
//       if (!snapshot.exists()) return { canPurchase: false, reason: 'User not found' };
      
//       const usersByDate = snapshot.val();
//       let userData = null;
//       let userDbKey = '';
//       let userRegistrationDate = '';
      
//       // Search through all date folders
//       for (const date in usersByDate) {
//         const users = usersByDate[date];
        
//         for (const [key, user] of Object.entries(users)) {
//           if (user.sponsorId === userId || key === userId) {
//             userData = user;
//             userDbKey = key;
//             userRegistrationDate = date;
//             break;
//           }
//         }
//         if (userData) break;
//       }
      
//       if (!userData) {
//         return { canPurchase: false, reason: 'User not found' };
//       }
      
//       // 1. Check login status
//       if (userData.loginStatus === 'blocked') {
//         return { canPurchase: false, reason: 'Your account is blocked from login' };
//       }
      
//       // 2. CRITICAL: If buying for downline, check downline activation status
//       if (isForDownline) {
//         if (userData.downlineActivationStatus === 'disabled') {
//           return { 
//             canPurchase: false, 
//             reason: 'You are BLOCKED from activating packages for downlines. Contact admin.' 
//           };
//         }
//       }
      
//       // 3. Check if user has active package (required for commissions)
//       const userPackages = userData.packages || [];
//       const hasActivePackage = userPackages.some(pkg => pkg && pkg.status === 'active');
      
//       if (!hasActivePackage) {
//         console.log('User has no active package - commissions may be affected');
//       }
      
//       // 4. Check level income status
//       if (userData.levelIncomeStatus === 'blocked') {
//         console.log('User has level income blocked - will not receive commissions');
//       }
      
//       return { 
//         canPurchase: true, 
//         reason: '',
//         userData,
//         dbKey: userDbKey,
//         registrationDate: userRegistrationDate
//       };
      
//     } catch (error) {
//       console.error('Error checking user purchase ability:', error);
//       return { canPurchase: false, reason: 'Error checking user status' };
//     }
//   };

//   // Check if target user can receive package
//   const canUserReceivePackage = async (targetUserId) => {
//     try {
//       const status = await getCompleteBlockStatus(targetUserId);
      
//       // CRITICAL: User cannot receive package if:
//       // 1. Login is blocked
//       // 2. Downline activation is disabled (for admin blocks on receiver)
//       if (status.loginStatus === 'blocked') {
//         return {
//           canReceive: false,
//           reason: 'Target user is blocked from login - cannot receive packages',
//           blockStatus: status
//         };
//       }
      
//       if (status.downlineActivationStatus === 'disabled') {
//         return {
//           canReceive: false,
//           reason: 'Target user has downline activation blocked - cannot receive packages',
//           blockStatus: status
//         };
//       }
      
//       return {
//         canReceive: true,
//         reason: '',
//         blockStatus: status
//       };
      
//     } catch (error) {
//       console.error('Error checking user receive ability:', error);
//       return { canReceive: false, reason: 'Error checking user status' };
//     }
//   };

//   const searchDownline = async () => {
//     if (!searchDownlineId.trim()) {
//       showError('Please enter a user ID to search');
//       return;
//     }

//     try {
//       const usersRef = ref(database, 'users');
//       const snapshot = await get(usersRef);
      
//       if (snapshot.exists()) {
//         const usersByDate = snapshot.val();
//         let foundUser = null;
//         let foundDbKey = '';
//         let foundRegistrationDate = '';
        
//         // Search through all date folders
//         for (const date in usersByDate) {
//           const users = usersByDate[date];
          
//           for (const [key, user] of Object.entries(users)) {
//             if (user.sponsorId === searchDownlineId || 
//                 key === searchDownlineId) {
//               foundUser = user;
//               foundDbKey = key;
//               foundRegistrationDate = date;
//               break;
//             }
//           }
//           if (foundUser) break;
//         }
        
//         if (foundUser) {
//           // Get complete block status
//           const blockStatus = await getCompleteBlockStatus(foundUser.sponsorId, foundRegistrationDate, foundDbKey);
          
//           // CRITICAL: Check if user can receive package
//           if (!blockStatus.canReceivePackage) {
//             showError(`User ${foundUser.name} cannot receive packages: ${blockStatus.blockReasons.join(', ')}`);
//             return;
//           }
          
//           setSelectedDownline(foundUser.sponsorId);
//           setSelectedDownlineName(foundUser.name);
//           setShowDownlineSearch(false);
//         } else {
//           showError('User not found');
//         }
//       }
//     } catch (error) {
//       console.error('Error searching downline:', error);
//       showError('Error searching user');
//     }
//   };

//   useEffect(() => {
//     if (isBuyingForDownline) {
//       fetchAllDownlines();
//     }
//   }, [isBuyingForDownline]);

//   const getPackageSequence = async (targetDbKey, targetRegistrationDate) => {
//     try {
//       const userRef = ref(database, `users/${targetRegistrationDate}/${targetDbKey}`);
//       const snapshot = await get(userRef);
      
//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         const packages = userData.packages || [];
//         return packages.length + 1;
//       }
//       return 1;
//     } catch (error) {
//       console.error('Error getting package sequence:', error);
//       return 1;
//     }
//   };

//   // Check if a user is active (has at least one active package) with date-wise structure
//   const isUserActive = (userData) => {
//     const userPackages = userData.packages || [];
//     return userPackages.some(pkg => pkg.status === 'active');
//   };

//   // Get upline chain with date-wise structure
//   const getUplineChain = async (sponsorId, maxLevels = 5) => {
//     try {
//       const usersRef = ref(database, 'users');
//       const snapshot = await get(usersRef);
      
//       if (!snapshot.exists()) return [];
      
//       const usersByDate = snapshot.val();
//       const uplineChain = [];
      
//       // First find the user to get their upline
//       let currentUplineId = '';
//       let currentDbKey = '';
//       let currentRegistrationDate = '';
      
//       for (const date in usersByDate) {
//         const users = usersByDate[date];
//         for (const [dbKey, user] of Object.entries(users)) {
//           if (user.sponsorId === sponsorId) {
//             currentUplineId = user.uplineSponsorId;
//             currentDbKey = dbKey;
//             currentRegistrationDate = date;
//             break;
//           }
//         }
//         if (currentUplineId) break;
//       }
      
//       if (!currentUplineId) return [];
      
//       let level = 1;
      
//       while (currentUplineId && level <= maxLevels) {
//         let uplineUser = null;
//         let uplineDbKey = '';
//         let uplineRegistrationDate = '';
        
//         // Find upline in date-wise structure
//         for (const date in usersByDate) {
//           const users = usersByDate[date];
//           for (const [dbKey, user] of Object.entries(users)) {
//             if (user.sponsorId === currentUplineId) {
//               uplineUser = user;
//               uplineDbKey = dbKey;
//               uplineRegistrationDate = date;
//               break;
//             }
//           }
//           if (uplineUser) break;
//         }
        
//         if (uplineUser) {
//           // Get complete block status for this upline
//           const blockStatus = await getCompleteBlockStatus(uplineUser.sponsorId, uplineRegistrationDate, uplineDbKey);
          
//           // Check if upline is active
//           const isActive = isUserActive(uplineUser);
          
//           uplineChain.push({
//             level: level,
//             user: uplineUser,
//             dbKey: uplineDbKey,
//             registrationDate: uplineRegistrationDate,
//             isActive: isActive,
//             blockStatus: blockStatus,
//             isBlocked: blockStatus.isBlocked,
//             isLevelIncomeBlocked: blockStatus.levelIncomeStatus === 'blocked' || blockStatus.levelIncomeCollectionBlocked,
//             isLoginBlocked: blockStatus.loginStatus === 'blocked',
//             isROIBlocked: blockStatus.roiStatus === 'blocked' || blockStatus.packageRoiStatus === 'blocked' || blockStatus.roiScheduleBlocked
//           });
          
//           currentUplineId = uplineUser.uplineSponsorId;
//           level++;
//         } else {
//           break;
//         }
//       }
      
//       return uplineChain;
//     } catch (error) {
//       console.error('Error getting upline chain:', error);
//       return [];
//     }
//   };

//   // Get upline's commission percentages based on THEIR package with date-wise structure
//   const getUplineCommissionPercentages = async (uplineDbKey, uplineRegistrationDate) => {
//     try {
//       const uplineRef = ref(database, `users/${uplineRegistrationDate}/${uplineDbKey}`);
//       const snapshot = await get(uplineRef);
      
//       if (snapshot.exists()) {
//         const uplineData = snapshot.val();
//         const uplinePackages = uplineData.packages || [];
        
//         const uplineActivePackage = uplinePackages
//           .filter(pkg => pkg.status === 'active')
//           .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))[0];
        
//         if (uplineActivePackage && uplineActivePackage.referralLevels) {
//           return uplineActivePackage.referralLevels;
//         }
//       }
      
//       return [9, 7, 4, 2, 1]; // Default Plan 1
//     } catch (error) {
//       console.error('Error getting upline commission percentages:', error);
//       return [9, 7, 4, 2, 1];
//     }
//   };

// const AUSTRALIA_TIMEZONE = "Asia/Dubai";

// const getAustraliaDateParts = (date = new Date()) => {
//   const parts = new Intl.DateTimeFormat("en-CA", {
//     timeZone: AUSTRALIA_TIMEZONE,
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: false
//   }).formatToParts(date);

//   const map = {};
//   parts.forEach((p) => {
//     if (p.type !== "literal") map[p.type] = p.value;
//   });

//   return {
//     year: Number(map.year),
//     month: Number(map.month),
//     day: Number(map.day),
//     hour: Number(map.hour),
//     minute: Number(map.minute),
//     second: Number(map.second)
//   };
// };

// const getDateKeyFromParts = ({ year, month, day }) =>
//   `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

// const addDaysToDateKey = (dateKey, days) => {
//   const [year, month, day] = dateKey.split("-").map(Number);
//   const utcDate = new Date(Date.UTC(year, month - 1, day));
//   utcDate.setUTCDate(utcDate.getUTCDate() + days);
//   return `${utcDate.getUTCFullYear()}-${String(utcDate.getUTCMonth() + 1).padStart(2, "0")}-${String(utcDate.getUTCDate()).padStart(2, "0")}`;
// };

// const getDayFromDateKey = (dateKey) => {
//   const [year, month, day] = dateKey.split("-").map(Number);
//   return new Date(Date.UTC(year, month - 1, day)).getUTCDay();
// };

// const normalizeWorkingDaysPattern = (workingDaysPattern) => {
//   const raw = String(workingDaysPattern || '').trim().toLowerCase();
//   if (!raw) return 'Mon-Fri';
//   if (raw === 'mon-fri' || raw === 'monday - friday' || raw === 'monday-friday') return 'Mon-Fri';
//   if (raw === 'mon-sat' || raw === 'monday - saturday' || raw === 'monday-saturday') return 'Mon-Sat';
//   if (raw === 'all' || raw === 'daily' || raw === 'everyday') return 'All';
//   return workingDaysPattern;
// };

// // Helper: Check if a day is a working day (using Dubai date key)
// const isWorkingDay = (workingDaysPattern = "Mon-Fri", dateOrKey = new Date()) => {
//   const normalizedPattern = normalizeWorkingDaysPattern(workingDaysPattern);
//   const dateKey = typeof dateOrKey === "string"
//     ? dateOrKey
//     : getDateKeyFromParts(getAustraliaDateParts(dateOrKey));

//   const day = getDayFromDateKey(dateKey); // 0 = Sunday

//   if (normalizedPattern === "Mon-Fri") return day >= 1 && day <= 5;
//   if (normalizedPattern === "Mon-Sat") return day >= 1 && day <= 6;
//   if (normalizedPattern === "All") return true;
//   return day >= 1 && day <= 5;
// };

// const getNextWorkingDayKey = (workingDaysPattern = "Mon-Fri", fromDateKey) => {
//   const normalizedPattern = normalizeWorkingDaysPattern(workingDaysPattern);
//   let nextKey = addDaysToDateKey(fromDateKey, 1);
//   while (!isWorkingDay(normalizedPattern, nextKey)) {
//     nextKey = addDaysToDateKey(nextKey, 1);
//   }
//   return nextKey;
// };

// const dateKeyToAESTMidnightIso = (dateKey) => {
//   const [year, month, day] = dateKey.split("-").map(Number);
//   const utcMillis = Date.UTC(year, month - 1, day, 0, 0, 0) - (4 * 60 * 60 * 1000);
//   return new Date(utcMillis).toISOString();
// };

// const parseDateKeyToUtcDate = (dateKey) => {
//   if (!dateKey) return null;
//   const [year, month, day] = dateKey.split("-").map(Number);
//   if (!year || !month || !day) return null;
//   return new Date(Date.UTC(year, month - 1, day));
// };

// const isWithinActivationWindow = (purchaseDate, registrationDate, windowDays) => {
//   if (!purchaseDate || !registrationDate) return false;
//   const startDate = parseDateKeyToUtcDate(registrationDate);
//   if (!startDate) return false;
//   const endDate = new Date(startDate);
//   endDate.setUTCDate(endDate.getUTCDate() + windowDays);
//   const purchase = new Date(purchaseDate);
//   return purchase >= startDate && purchase <= endDate;
// };

// const countEligiblePackagesWithinWindow = (packages, registrationDate, windowDays) => {
//   if (!Array.isArray(packages)) return 0;
//   return packages.filter((pkg) => {
//     if (!pkg) return false;
//     const status = String(pkg.status || 'active').toLowerCase();
//     if (status !== 'active' && status !== 'completed') return false;
//     const purchaseDate = pkg.purchaseDate || pkg.date || pkg.purchaseTimestamp;
//     return isWithinActivationWindow(purchaseDate, registrationDate, windowDays);
//   }).length;
// };

//   // Level commissions - Only distribute to ACTIVE and NOT BLOCKED uplines (max 5 levels)
//   const distributeLevelIncome = async (buyerSponsorId, buyerName, buyerPackageInfo, totalAmount, transactionId, packageSequence, maxLevels = 5) => {
//     try {
//       const timestamp = new Date().toISOString();
//       const uplineChain = await getUplineChain(buyerSponsorId, maxLevels);
      
//       console.log(`Distributing commissions for ${buyerName} to ${uplineChain.length} uplines (max ${maxLevels} levels)`);
      
//       // Distribute Level commissions from investment
//       for (const upline of uplineChain) {
//         if (upline.level > maxLevels) break;
        
//         // Check if upline is active
//         if (!upline.isActive) {
//           console.log(`⏭️ Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} is inactive`);
//           continue; // Skip inactive uplines
//         }
        
//         // Check if upline is blocked
//         if (upline.isBlocked) {
//           console.log(`🚫 Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} is blocked`);
//           continue; // Skip blocked uplines
//         }
        
//         // Check if upline is specifically blocked from level income
//         if (upline.isLevelIncomeBlocked) {
//           console.log(`🚫 Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} has level income blocked`);
//           continue;
//         }
        
//         // Check if upline is login blocked
//         if (upline.isLoginBlocked) {
//           console.log(`🚫 Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} is login blocked`);
//           continue;
//         }
        
//         // Get commission percentages from UPLINE'S active package
//         const uplineCommissionLevels = await getUplineCommissionPercentages(upline.dbKey, upline.registrationDate);
//         const commissionPercent = uplineCommissionLevels[upline.level - 1] || 0;
        
//         if (commissionPercent > 0) {
//           const commissionAmount = (totalAmount * commissionPercent) / 100;
          
//           if (commissionAmount > 0) {
//             // Add to upline's working wallet with date-wise structure
//             const currentWorking = parseFloat(upline.user.wallets?.working) || 0;
//             const newWorking = currentWorking + commissionAmount;
            
//             const uplineRef = ref(database, `users/${upline.registrationDate}/${upline.dbKey}`);
//             await update(uplineRef, {
//               'wallets/working': newWorking,
//               totalEarnings: (parseFloat(upline.user.totalEarnings) || 0) + commissionAmount,
//               updatedAt: timestamp
//             });
            
//             // Record the level income with date-wise structure
//             const levelIncomeId = `${transactionId}_L${upline.level}`;
//             const incomeDate = new Date().toISOString().split('T')[0];
//             const userLevelIncomeRef = ref(database, `levelIncomes/${incomeDate}/${upline.dbKey}/${levelIncomeId}`);
            
//             await set(userLevelIncomeRef, {
//               incomeId: levelIncomeId,
//               userId: upline.user.sponsorId,
//               userName: upline.user.name || 'Unknown',
//               sponsorId: upline.user.sponsorId,
//               fromUserId: buyerSponsorId,
//               fromUserName: buyerName,
//               type: 'level_income',
//               level: upline.level,
//               amount: commissionAmount,
//               percentage: commissionPercent,
//               packageAmount: totalAmount,
//               fromPackageName: buyerPackageInfo.name,
//               fromPackageCommission: buyerPackageInfo.referralLevels || [0, 0, 0, 0, 0],
//               uplinePackageCommission: uplineCommissionLevels,
//               date: timestamp,
//               status: 'credited',
//               description: `Level ${upline.level} commission (${commissionPercent}%) from ${buyerName}'s ${buyerPackageInfo.name} purchase.`,
//               transactionId: transactionId,
//               source: 'package_investment',
//               isRecurring: false,
//               packageSequence: packageSequence,
//               isDirect: upline.level === 1,
//               note: 'Commission credited because upline is active and not blocked',
//               uplineStatus: 'active',
//               maxLevelsApplied: maxLevels,
//               blockCheck: {
//                 isBlocked: false,
//                 levelIncomeBlocked: false,
//                 loginBlocked: false,
//                 roiBlocked: upline.isROIBlocked
//               }
//             });
            
//             console.log(`✅ Level ${upline.level} commission distributed: $${commissionAmount.toFixed(2)} to ${upline.user.sponsorId}`);
//           }
//         }
//       }
      
//       return true;
//     } catch (error) {
//       console.error('Error distributing level income:', error);
//       throw error;
//     }
//   };
// // In ActivatePackage.js - Fix the scheduleDailyROI function

// // ROI Schedule with date-wise structure - FIXED FOR CORRECT MIDNIGHT CREDIT
// const scheduleDailyROI = async (targetUser, packageData, investmentAmount, transactionId, packageSequence, targetRegistrationDate) => {
//   try {
//     const scheduleId = `${transactionId}_ROI`;
//     const purchaseDate = new Date();
//     const australiaNowParts = getAustraliaDateParts(purchaseDate);
//     const australiaTodayKey = getDateKeyFromParts(australiaNowParts);
    
//     // Get complete block status for target user
//     const blockStatus = await getCompleteBlockStatus(targetUser.userId, targetRegistrationDate, targetUser.dbKey);
    
//     // Check if user is ROI blocked
//     const isROIBlocked = blockStatus.roiStatus === 'blocked' || 
//                         blockStatus.packageRoiStatus === 'blocked' || 
//                         blockStatus.roiScheduleBlocked ||
//                         blockStatus.loginStatus === 'blocked';

//     // Create date-wise ROI structure
//     const todayDate = australiaTodayKey;
//     const roiRef = ref(database, `ROISchedule/${todayDate}/${targetUser.userId}/${scheduleId}`);
    
//     const startDate = purchaseDate.toISOString();
//     const endDate = new Date(purchaseDate.getTime() + (packageData.durationDays * 24 * 60 * 60 * 1000)).toISOString();
    
//     // Calculate daily ROI amount
//     const dailyROIAmount = (investmentAmount * parseFloat(packageData.dailyRoi)) / 100;
    
//     console.log(`📊 ROI Calculation for ${targetUser.userName}:`);
//     console.log(`   Investment: $${investmentAmount}`);
//     console.log(`   Daily ROI %: ${packageData.dailyRoi}%`);
//     console.log(`   Daily ROI Amount: $${dailyROIAmount}`);
//     console.log(`   Purchase Time (Dubai): ${purchaseDate.toLocaleString('en-AU', { timeZone: AUSTRALIA_TIMEZONE })}`);

//     // Cutoff behavior:
//     // - If purchased before Dubai 12:00 AM boundary in user's local equivalent (e.g. 7:30 PM IST),
//     //   credit at the immediate Dubai midnight.
//     // - If purchased after that boundary, credit next Dubai midnight.
//     let firstRoiDateKey = australiaTodayKey;
//     if (australiaNowParts.hour > 0 || australiaNowParts.minute > 0 || australiaNowParts.second > 0) {
//       firstRoiDateKey = addDaysToDateKey(firstRoiDateKey, 1);
//       console.log(`   ⏰ Purchased at ${australiaNowParts.hour}:${String(australiaNowParts.minute).padStart(2, "0")} Dubai time, first ROI next Dubai midnight`);
//     } else {
//       console.log("   ⏰ Purchased exactly at Dubai midnight, first ROI today at midnight");
//     }

//     const workingDaysPattern = normalizeWorkingDaysPattern(packageData.workingDays || 'Mon-Fri');
//     if (!isWorkingDay(workingDaysPattern, firstRoiDateKey)) {
//       const originalDateKey = firstRoiDateKey;
//       firstRoiDateKey = getNextWorkingDayKey(workingDaysPattern, addDaysToDateKey(firstRoiDateKey, -1));
//       console.log(`   📅 ${originalDateKey} is not a working day, moved to ${firstRoiDateKey}`);
//     }
//     const firstRoiDateIso = dateKeyToAESTMidnightIso(firstRoiDateKey);
//     console.log(`   ✅ First ROI Date Key: ${firstRoiDateKey} (12:00 AM Dubai time)`);
    
//     // Get upline chain for energy wallet
//     const uplineChain = await getUplineChain(targetUser.sponsorId, 1);
//     const directUpline = uplineChain.find(u => u.level === 1);
    
//     // Calculate energy wallet
//     let energyWalletInfo = null;
//     if (directUpline && directUpline.isActive && !directUpline.isBlocked && !directUpline.isLevelIncomeBlocked && !directUpline.isLoginBlocked) {
//       const energyPercent = packageData.energyWallet || 4;
//       const dailyEnergyAmount = (dailyROIAmount * energyPercent) / 100;
      
//       // Calculate first energy date (same logic as ROI)
//       let firstEnergyDateKey = australiaTodayKey;
//       if (australiaNowParts.hour > 0 || australiaNowParts.minute > 0 || australiaNowParts.second > 0) {
//         firstEnergyDateKey = addDaysToDateKey(firstEnergyDateKey, 1);
//       }
//       if (!isWorkingDay(workingDaysPattern, firstEnergyDateKey)) {
//         firstEnergyDateKey = getNextWorkingDayKey(workingDaysPattern, addDaysToDateKey(firstEnergyDateKey, -1));
//       }
      
//       energyWalletInfo = {
//         uplineUserId: directUpline.user.sponsorId,
//         uplineUserName: directUpline.user.name || 'Unknown',
//         uplineSponsorId: directUpline.user.sponsorId,
//         uplineDbKey: directUpline.dbKey,
//         uplineRegistrationDate: directUpline.registrationDate,
//         energyPercentage: energyPercent,
//         dailyEnergyAmount: dailyEnergyAmount,
//         energyCredited: 0,
//         totalEnergyReceived: 0,
//         lastEnergyCredit: null,
//         nextEnergyCredit: dateKeyToAESTMidnightIso(firstEnergyDateKey),
//         nextEnergyCreditKey: firstEnergyDateKey,
//         isActive: true,
//         requiresWorkingDay: true,
//         workingDaysPattern: workingDaysPattern,
//         note: 'Active upline receives energy wallet at midnight Dubai time',
//         creditTime: '12:00 AM GST'
//       };
//     }
    
//     const roiScheduleData = {
//       scheduleId: scheduleId,
//       userId: targetUser.userId,
//       sponsorId: targetUser.sponsorId,
//       userName: targetUser.userName,
//       packageName: packageData.name,
//       packageId: packageData.id,
//       investmentAmount: investmentAmount,
//       totalAmount: investmentAmount,
//       dailyROI: parseFloat(packageData.dailyRoi) || 0,
//       dailyROIAmount: dailyROIAmount,
//       roiCreditDays: 1, // Daily
//       roiCreditTime: '12:00 AM',
//       startDate: startDate,
//       endDate: endDate,
//       status: isROIBlocked ? 'blocked' : 'active',
//       roiStatus: isROIBlocked ? 'blocked' : 'active',
//       blockStatus: {
//         userROIBlocked: blockStatus.roiStatus === 'blocked',
//         packageROIBlocked: blockStatus.packageRoiStatus === 'blocked',
//         roiScheduleBlocked: blockStatus.roiScheduleBlocked,
//         loginBlocked: blockStatus.loginStatus === 'blocked',
//         isROIBlocked: isROIBlocked,
//         blockReasons: blockStatus.blockReasons
//       },
//       nextRoiDate: firstRoiDateIso,
//       nextRoiDateKey: firstRoiDateKey,
//       workingDays: packageData.workingDays || 'Mon-Fri',
//       transactionId: transactionId,
//       createdAt: startDate,
//       directUplineId: userUplineId,
//       roiCredited: 0,
//       totalROIEarned: 0,
//       totalExpectedROI: dailyROIAmount * (packageData.durationDays || 365),
//       packageSequence: packageSequence,
//       lastRoiDistribution: null,
//       energyWalletInfo: energyWalletInfo,
//       energyCredited: 0,
//       totalEnergyExpected: 0,
//       purchaseTimestamp: purchaseDate.toISOString(),
//       purchaseTimeAustralia: purchaseDate.toLocaleString('en-AU', { timeZone: AUSTRALIA_TIMEZONE }),
//       purchaseHourAustralia: australiaNowParts.hour,
//       purchaseMinuteAustralia: australiaNowParts.minute,
//       nextWorkingDayCalculation: packageData.workingDays || 'Mon-Fri',
//       targetRegistrationDate: targetRegistrationDate,
//       buyerSponsorId: userSponsorId,
//       note: isROIBlocked ? 'ROI blocked by admin' : 'ROI credits at midnight Dubai time',
//       calculationNote: `ROI: $${investmentAmount} × ${packageData.dailyRoi}% = $${dailyROIAmount}/day at midnight GST`,
//       isMidnightCredit: true,
//       creditTimeDescription: 'Credits exactly at 12:00 AM Dubai time daily',
//       purchaseTimeDescription: `Purchased at ${australiaNowParts.hour}:${String(australiaNowParts.minute).padStart(2, "0")} Dubai time`,
//       firstRoiDescription: `First ROI at midnight on ${firstRoiDateKey} (Dubai)`
//     };
    
//     await set(roiRef, roiScheduleData);
    
//     console.log(`✅ ROI SCHEDULE CREATED for ${targetUser.userName}:`);
//     console.log(`   Package: ${packageData.name}`);
//     console.log(`   Investment: $${investmentAmount}`);
//     console.log(`   Daily ROI: $${dailyROIAmount} (${packageData.dailyRoi}%)`);
//     console.log(`   First ROI: ${firstRoiDateKey} 12:00 AM (Dubai)`);
//     console.log(`   ⏰ CREDIT TIME: Fixed at 12:00 AM Dubai time daily`);
    
//     return {
//       success: true,
//       dailyROIAmount: dailyROIAmount,
//       firstRoiDate: firstRoiDateIso,
//       scheduleId: scheduleId,
//       isROIBlocked: isROIBlocked,
//       blockReasons: isROIBlocked ? blockStatus.blockReasons : []
//     };
    
//   } catch (error) {
//     console.error('❌ Error scheduling ROI:', error);
//     throw error;
//   }
// };

//   const calculateExpectedTotalROI = (totalAmount, dailyROIPercent, durationDays, workingDaysPattern) => {
//     const normalizedPattern = normalizeWorkingDaysPattern(workingDaysPattern);
//     let totalWorkingDays = durationDays;
    
//     if (normalizedPattern === 'Mon-Fri') {
//       totalWorkingDays = Math.floor(durationDays * (5/7));
//     } else if (normalizedPattern === 'Mon-Sat') {
//       totalWorkingDays = Math.floor(durationDays * (6/7));
//     }
    
//     const dailyROI = (totalAmount * dailyROIPercent) / 100;
//     return {
//       dailyROIAmount: dailyROI,
//       totalExpectedROI: dailyROI * totalWorkingDays,
//       totalWorkingDays: totalWorkingDays
//     };
//   };

//   const handlePurchase = async () => {
//     if (!confirmData || isProcessing) return;
    
//     setIsProcessing(true);

//     const { package: pkg, amount: investAmount, totalPackageValue, 
//             targetUserName, targetUserId, isForDownline, dailyROIAmount, packageSequence,
//             energyPercent, dailyEnergyAmount, targetRegistrationDate } = confirmData;

//     try {
//       let targetUser = {
//         dbKey: userDbKey,
//         userId: userId,
//         userName: userName,
//         sponsorId: userSponsorId,
//         registrationDate: userRegistrationDate
//       };

//       if (isForDownline && selectedDownline) {
//         const downline = downlineList.find(r => r.userId === targetUserId);
//         if (downline) {
//           targetUser = {
//             dbKey: downline.dbKey,
//             userId: downline.userId,
//             userName: downline.name,
//             sponsorId: downline.sponsorId,
//             registrationDate: downline.registrationDate || '2026-02-06'
//           };
//         }
//       }

//       const timestamp = new Date().toISOString();
//       const transactionId = `PKG${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

//       console.log(`🛒 Purchase started for ${targetUser.userName}:`);
//       console.log(`   Package: ${pkg.name}`);
//       console.log(`   Amount: $${investAmount}`);
//       console.log(`   ROI %: ${pkg.dailyRoi}%`);
//       console.log(`   Expected Daily ROI: $${dailyROIAmount}`);

//       // CRITICAL: Check if buyer can purchase (especially important for downline activation)
//       const buyerCheck = await canUserPurchase(userId, isForDownline);
//       if (!buyerCheck.canPurchase) {
//         showError(buyerCheck.reason);
//         setIsProcessing(false);
//         return;
//       }

//       // CRITICAL: If buying for downline, double-check downline activation status
//       if (isForDownline) {
//         // Check again from Firebase to ensure real-time status
//         const usersRef = ref(database, 'users');
//         const snapshot = await get(usersRef);
        
//         if (snapshot.exists()) {
//           const usersByDate = snapshot.val();
//           let buyerData = null;
          
//           // Find buyer in date-wise structure
//           for (const date in usersByDate) {
//             const users = usersByDate[date];
//             for (const [key, user] of Object.entries(users)) {
//               if (user.sponsorId === userId) {
//                 buyerData = user;
//                 break;
//               }
//             }
//             if (buyerData) break;
//           }
          
//           // CRITICAL: Final check - if downline activation is disabled, block purchase
//           if (buyerData && buyerData.downlineActivationStatus === 'disabled') {
//             showError('Your downline activation privileges have been BLOCKED by admin. You cannot purchase packages for downlines.');
//             setIsProcessing(false);
//             return;
//           }
//         }
//       }

//       // CRITICAL: Check if target user can receive package
//       if (isForDownline && targetUserId !== userId) {
//         const targetCheck = await canUserReceivePackage(targetUserId);
//         if (!targetCheck.canReceive) {
//           showError(targetCheck.reason);
//           setIsProcessing(false);
//           return;
//         }
//       }

//       // Deduct from buyer's wallet with date-wise structure
//       const buyerRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const buyerSnapshot = await get(buyerRef);
//       const buyerData = buyerSnapshot.val();
      
//       const updateData = {
//         updatedAt: timestamp
//       };
      
//       if (selectedWallet === 'aurum') {
//         const newBalance = (parseFloat(buyerData.wallets?.aurum) || 0) - investAmount;
//         updateData['wallets/aurum'] = newBalance;
//         console.log(`💰 Deducted $${investAmount} from aurum wallet. New balance: $${newBalance}`);
//       } else if (selectedWallet === 'fund') {
//         const newBalance = (parseFloat(buyerData.fund?.balance) || 0) - investAmount;
//         updateData['fund/balance'] = newBalance;
//         console.log(`💰 Deducted $${investAmount} from fund wallet. New balance: $${newBalance}`);
//       }
      
//       await update(buyerRef, updateData);

//       // Add package to target user with date-wise structure
//       const targetRef = ref(database, `users/${targetUser.registrationDate}/${targetUser.dbKey}`);
//       const targetSnapshot = await get(targetRef);
//       const targetData = targetSnapshot.val() || {};

//       // Calculate expected total ROI
//       const expectedROI = calculateExpectedTotalROI(
//         investAmount,
//         parseFloat(pkg.dailyRoi),
//         pkg.durationDays || 365,
//         pkg.workingDays || 'Mon-Fri'
//       );

//       // Get upline chain to check direct upline status
//       const uplineChain = await getUplineChain(targetUser.sponsorId, 1);
//       const directUpline = uplineChain.find(u => u.level === 1);
//       const isDirectUplineActive = directUpline ? directUpline.isActive : false;
//       const isDirectUplineBlocked = directUpline ? directUpline.isBlocked : false;
//       const isDirectUplineLevelIncomeBlocked = directUpline ? directUpline.isLevelIncomeBlocked : false;

//       const packageEntry = {
//         packageId: pkg.id,
//         packageName: pkg.name,
//         investmentAmount: investAmount,
//         totalAmount: investAmount,
//         dailyROI: parseFloat(pkg.dailyRoi) || 0,
//         dailyROIAmount: dailyROIAmount,
//         expectedTotalROI: expectedROI.totalExpectedROI,
//         roiCreditDays: parseInt(pkg.roiCreditDays) || 5,
//         workingDays: pkg.workingDays || 'Mon-Fri',
//         purchaseDate: timestamp,
//         expiryDate: new Date(Date.now() + ((pkg.durationDays || 365) * 24 * 60 * 60 * 1000)).toISOString(),
//         status: 'active',
//         purchasedBy: isForDownline ? userId : 'self',
//         transactionId: transactionId,
//         packageSequence: packageSequence,
//         durationDays: pkg.durationDays || 365,
//         directUplineId: userUplineId,
//         roiCredited: 0,
//         roiPending: expectedROI.totalExpectedROI,
//         referralLevels: pkg.referralLevels || [0, 0, 0, 0, 0],
//         energyWalletScheduled: true,
//         energyPercentage: energyPercent,
//         dailyEnergyAmount: dailyEnergyAmount,
//         directUplineActive: isDirectUplineActive,
//         directUplineBlocked: isDirectUplineBlocked,
//         directUplineLevelIncomeBlocked: isDirectUplineLevelIncomeBlocked,
//         purchaseTimestamp: timestamp,
//         walletUsed: selectedWallet === 'aurum' ? 'Aerovolt' : 'AV PAY',
//         blockCheck: {
//           buyerBlocked: false,
//           targetBlocked: false,
//           directUplineBlocked: isDirectUplineBlocked
//         }
//       };

//       const existingPackages = targetData.packages || [];
//       const newPackages = [...existingPackages, packageEntry];
      
//       const targetUpdateData = {
//         packages: newPackages,
//         totalInvestment: (parseFloat(targetData.totalInvestment) || 0) + investAmount,
//         status: 'active',
//         updatedAt: timestamp
//       };

//       let activationBonusAwarded = false;
//       let activationBonusAmount = 0;
//       let activationBonusTransactionId = null;
//       let activationBonusPreviousWorking = parseFloat(targetData.wallets?.working) || 0;
//       let activationBonusNewWorking = activationBonusPreviousWorking;

//       if (
//         activationRuleLoaded &&
//         activationBonusRule.enabled &&
//         !targetData.activationBonus?.awarded &&
//         activationBonusRule.bonusAmount > 0
//       ) {
//         const requiredPackages = parseInt(activationBonusRule.requiredPackages, 10) || 3;
//         const windowDays = parseInt(activationBonusRule.windowDays, 10) || 45;
//         const eligibleCount = countEligiblePackagesWithinWindow(
//           newPackages,
//           targetUser.registrationDate,
//           windowDays
//         );

//         if (eligibleCount >= requiredPackages) {
//           activationBonusAwarded = true;
//           activationBonusAmount = parseFloat(activationBonusRule.bonusAmount) || 0;
//           activationBonusTransactionId = `ACT_BONUS_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
//           activationBonusNewWorking = activationBonusPreviousWorking + activationBonusAmount;

//           targetUpdateData['wallets/working'] = activationBonusNewWorking;
//           targetUpdateData.totalEarnings = (parseFloat(targetData.totalEarnings) || 0) + activationBonusAmount;
//           targetUpdateData.activationBonus = {
//             awarded: true,
//             awardedAt: timestamp,
//             bonusAmount: activationBonusAmount,
//             requiredPackages,
//             windowDays,
//             wallet: activationBonusRule.wallet || 'working',
//             transactionId: activationBonusTransactionId,
//             description: `Activated ${requiredPackages} packages within ${windowDays} days`
//           };
//         }
//       }
      
//       await update(targetRef, targetUpdateData);
//       console.log(`✅ Package added to ${targetUser.userName}'s account`);

//       if (activationBonusAwarded) {
//         await recordWorkingWalletBonus({
//           targetUser,
//           bonusAmount: activationBonusAmount,
//           previousBalance: activationBonusPreviousWorking,
//           newBalance: activationBonusNewWorking,
//           transactionId: activationBonusTransactionId,
//           description: `Activation bonus: ${activationBonusRule.requiredPackages} packages in ${activationBonusRule.windowDays} days`
//         });
//       }

//       // Distribute Level commissions only to ACTIVE and NOT BLOCKED uplines
//       await distributeLevelIncome(targetUser.sponsorId, targetUser.userName, pkg, investAmount, transactionId, packageSequence, 5);

//       // Schedule Daily ROI with complete block check
//       const roiResult = await scheduleDailyROI(
//         targetUser, 
//         pkg, 
//         investAmount,
//         transactionId, 
//         packageSequence, 
//         targetUser.registrationDate
//       );
      
//       if (roiResult.isROIBlocked) {
//         console.log(`⚠️ ROI scheduled but blocked for ${targetUser.userName}: ${roiResult.blockReasons.join(', ')}`);
//       } else {
//         console.log(`✅ ROI Schedule created successfully for ${targetUser.userName}`);
//       }

//       // Update balances and user active package
//       await fetchUserBalances(userDbKey, userRegistrationDate);
//       if (!isForDownline) {
//         await fetchUserActivePackage(userDbKey, userRegistrationDate);
//       }
      
//       // Refresh fund wallet transactions
//       await fetchFundWalletTransactions(userId, userDbKey);

//       // Show success notification
//       let successMsg = '';
//       if (isForDownline) {
//         successMsg = `Package successfully gifted to ${targetUserName}! Daily ROI: $${dailyROIAmount}`;
//         if (roiResult.isROIBlocked) {
//           successMsg += ` (Note: ROI is blocked for this user)`;
//         }
//       } else {
//         successMsg = `Package ${pkg.name} activated successfully! Daily ROI: $${dailyROIAmount}`;
//         if (roiResult.isROIBlocked) {
//           successMsg += ` (Note: Your ROI is blocked by admin)`;
//         }
//       }
//       if (activationBonusAwarded) {
//         successMsg += ` + $${activationBonusAmount.toFixed(2)} Working Wallet bonus`;
//       }

//       const scratchReward = generateScratchReward();
//       setScratchRewardAmount(scratchReward);
//       setScratchReferenceId(transactionId);
//       setShowScratchDialog(true);
//       successMsg += ` + Scratch card unlocked (minimum $${PACKAGE_SCRATCH_MIN_REWARD})`;
      
//       showSuccess(successMsg);

//       // Reset form
//       setSelectedPackage('');
//       setAmount('');
//       setSelectedDownline('');
//       setSelectedDownlineName('');
//       setIsBuyingForDownline(false);
//       setConfirmData(null);

//     } catch (error) {
//       console.error('❌ Purchase error:', error);
//       showError('Failed to activate package. Please try again.');
//     } finally {
//       setIsProcessing(false);
//       setShowConfirmDialog(false);
//     }
//   };

//   const showConfirmation = async () => {
//     if (!selectedPackage || !amount) {
//       showError('Please select package and enter amount');
//       return;
//     }

//     const pkg = packages.find(p => p.id === selectedPackage);
//     if (!pkg) {
//       showError('Invalid package selected');
//       return;
//     }

//     const investAmount = parseFloat(amount);
    
//     if (isNaN(investAmount) || investAmount < pkg.minInvestment) {
//       showError(`Minimum investment is $${pkg.minInvestment}`);
//       return;
//     }
    
//     if (pkg.maxInvestment !== 'Unlimited' && investAmount > pkg.maxInvestment) {
//       showError(`Maximum investment is $${pkg.maxInvestment}`);
//       return;
//     }
    
//     if (investAmount > walletBalances[selectedWallet]) {
//       showError(`Insufficient balance in ${selectedWallet === 'aurum' ? 'Aerovolt' : 'AV PAY'} wallet`);
//       return;
//     }

//     let targetUser = {
//       dbKey: userDbKey,
//       userId: userId,
//       userName: userName,
//       sponsorId: userSponsorId,
//       registrationDate: userRegistrationDate
//     };

//     if (isBuyingForDownline && selectedDownline) {
//       const downline = downlineList.find(r => r.userId === selectedDownline);
//       if (downline) {
//         targetUser = {
//           dbKey: downline.dbKey,
//           userId: downline.userId,
//           userName: downline.name,
//           sponsorId: downline.sponsorId,
//           registrationDate: downline.registrationDate || '2026-02-06'
//         };
        
//         // CRITICAL: Check if downline can receive package
//         const targetCheck = await canUserReceivePackage(downline.userId);
//         if (!targetCheck.canReceive) {
//           showError(targetCheck.reason);
//           return;
//         }
//       } else {
//         showError('Selected user not found');
//         return;
//       }
//     } else if (isBuyingForDownline && !selectedDownline) {
//       showError('Please select a downline member');
//       return;
//     }

//     // CRITICAL: Check if buyer can purchase
//     const buyerCheck = await canUserPurchase(userId, isBuyingForDownline);
//     if (!buyerCheck.canPurchase) {
//       showError(buyerCheck.reason);
//       return;
//     }

//     const packageSequence = await getPackageSequence(targetUser.dbKey, targetUser.registrationDate);
//     const totalPackageValue = investAmount;
//     const dailyROIAmount = (totalPackageValue * parseFloat(pkg.dailyRoi)) / 100;

//     // Get energy percentage FROM BUYER'S PACKAGE DATA
//     const energyPercent = pkg.energyWallet || 4;
//     const dailyEnergyAmount = (dailyROIAmount * energyPercent) / 100;

//     // Get upline chain to check if direct upline is active and not blocked
//     const uplineChain = await getUplineChain(targetUser.sponsorId, 1);
//     const directUpline = uplineChain.find(u => u.level === 1);
//     const isDirectUplineActive = directUpline ? directUpline.isActive : false;
//     const isDirectUplineBlocked = directUpline ? directUpline.isBlocked : false;
//     const isDirectUplineLevelIncomeBlocked = directUpline ? directUpline.isLevelIncomeBlocked : false;

//     // Get YOUR commission levels (for display)
//     const yourCommissionLevels = userActivePackage?.referralLevels || pkg.referralLevels || [0, 0, 0, 0, 0];

//     // Get complete block status for target user
//     const targetBlockStatus = await getCompleteBlockStatus(targetUser.userId, targetUser.registrationDate, targetUser.dbKey);

//     const confirmationData = {
//       package: pkg,
//       amount: investAmount,
//       totalPackageValue,
//       dailyROIAmount,
//       dailyEnergyAmount,
//       energyPercent,
//       isForDownline: isBuyingForDownline,
//       targetUserName: targetUser.userName,
//       targetUserId: targetUser.userId,
//       targetRegistrationDate: targetUser.registrationDate,
//       packageSequence,
//       walletUsed: selectedWallet === 'aurum' ? 'Aerovolt Wallet' : 'AV PAY Wallet',
//       packageName: pkg.name,
//       yourCommissionLevels: yourCommissionLevels,
//       buyerCommissionLevels: pkg.referralLevels || [0, 0, 0, 0, 0],
//       isDirectUplineActive: isDirectUplineActive,
//       isDirectUplineBlocked: isDirectUplineBlocked,
//       isDirectUplineLevelIncomeBlocked: isDirectUplineLevelIncomeBlocked,
//       targetBlockStatus: targetBlockStatus
//     };

//     setConfirmData(confirmationData);
//     setShowConfirmDialog(true);
//   };

//   // Dialog Component
//   const Dialog = ({ isOpen, onClose, children, title, showCloseButton = true }) => {
//     if (!isOpen) return null;

//     return (
//       <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70">
//         <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
//           {(title || showCloseButton) && (
//             <div className="flex items-center justify-between p-6 border-b border-gray-800">
//               {title && <h3 className="text-xl font-bold text-white">{title}</h3>}
//               {showCloseButton && (
//                 <button
//                   onClick={onClose}
//                   className="text-gray-400 hover:text-white transition-colors"
//                   disabled={isProcessing}
//                 >
//                   <X size={24} />
//                 </button>
//               )}
//             </div>
//           )}
//           <div className="p-6">
//             {children}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD',
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch (error) {
//       return dateString;
//     }
//   };

//   // Get status badge
//   const getStatusBadge = (status) => {
//     if (status === 'completed' || status === 'success') {
//       return (
//         <span className="inline-flex items-center px-2 py-1 rounded text-xs bg-green-500/20 text-green-400 border border-green-500/30">
//           <Check className="h-3 w-3 mr-1" />
//           Completed
//         </span>
//       );
//     }
//     if (status === 'pending') {
//       return (
//         <span className="inline-flex items-center px-2 py-1 rounded text-xs bg-yellow-500/20 text-yellow-400 border border-yellow-500/30">
//           <Clock className="h-3 w-3 mr-1" />
//           Pending
//         </span>
//       );
//     }
//     return (
//       <span className="inline-flex items-center px-2 py-1 rounded text-xs bg-gray-500/20 text-gray-400 border border-gray-500/30">
//         {status}
//       </span>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
//       </div>
//     );
//   }

//   const selectedPkg = packages.find(p => p.id === selectedPackage);

//   // Render downline status badges
//   const renderStatusBadges = (downline) => {
//     if (!downline) return null;
    
//     const badges = [];
    
//     if (downline.loginStatus === 'blocked') {
//       badges.push({ text: 'Login Blocked', color: 'red' });
//     }
//     if (downline.downlineActivationStatus === 'disabled') {
//       badges.push({ text: 'Downline Activation Blocked', color: 'red' });
//     }
//     if (downline.roiStatus === 'blocked') {
//       badges.push({ text: 'ROI Blocked', color: 'red' });
//     }
//     if (downline.levelIncomeStatus === 'blocked') {
//       badges.push({ text: 'Commission Blocked', color: 'red' });
//     }
//     if (downline.withdrawalStatus === 'blocked') {
//       badges.push({ text: 'Withdrawal Blocked', color: 'orange' });
//     }
//     if (downline.internalTransferStatus === 'blocked') {
//       badges.push({ text: 'Transfer Blocked', color: 'orange' });
//     }
    
//     if (badges.length === 0) return null;
    
//     return (
//       <div className="flex flex-wrap gap-1 mt-1">
//         {badges.map((badge, index) => (
//           <span 
//             key={index}
//             className={`px-1.5 py-0.5 text-[10px] rounded-full border ${
//               badge.color === 'red' 
//                 ? 'bg-red-500/10 text-red-300 border-red-500/20' 
//                 : 'bg-orange-500/10 text-orange-300 border-orange-500/20'
//             }`}
//           >
//             {badge.text}
//           </span>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="max-w-6xl mx-auto pt-20 px-4">
//       <h1 className="text-3xl font-bold text-white mb-8">Activate Package</h1>

//       {/* CRITICAL: Show warning if user is blocked from downline activation */}
//       {currentUserBlockStatus.downlineActivationStatus === 'disabled' && (
//         <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-xl">
//           <div className="flex items-center gap-3">
//             <Shield className="text-red-400" size={24} />
//             <div>
//               <h3 className="text-lg font-bold text-red-400">Downline Activation BLOCKED</h3>
//               <p className="text-gray-300">
//                 You have been blocked from activating packages for downline members by the administrator.
//                 You can still activate packages for yourself only.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Show user's current package info */}
//       {userActivePackage && (
//         <div className="mb-6 p-4 bg-primary/10 border border-primary/30 rounded-xl">
//           <div className="flex items-center gap-3">
//             <Package className="text-primary" size={24} />
//             <div>
//               <h3 className="text-lg font-bold text-primary">Your Active Package</h3>
//               <p className="text-white">{userActivePackage.packageName}</p>
//               <p className="text-gray-300 text-sm">
//                 Commission rates: {userActivePackage.referralLevels?.join('/')}% (max 5 levels)
//               </p>
//               <p className="text-gray-300 text-sm">
//                 Energy from referrals: {userActivePackage.energyPercentage || 4}% 
//                 <span className="ml-2 text-red-400">(Only if you're active & not blocked)</span>
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Success Notification */}
//       {showSuccessNotification && (
//         <div className="fixed right-4 top-24 z-50 animate-slide-in-right">
//           <div className="bg-gradient-to-r from-green-500/20 to-green-600/20 backdrop-blur-sm border border-green-500/30 rounded-xl p-4 shadow-2xl max-w-sm">
//             <div className="flex items-center gap-3">
//               <div className="bg-green-500/20 p-2 rounded-full">
//                 <Check className="text-green-400" size={20} />
//               </div>
//               <div className="flex-1">
//                 <h4 className="font-bold text-green-400">Success!</h4>
//                 <p className="text-white text-sm">{successMessage}</p>
//               </div>
//               <button
//                 onClick={() => setShowSuccessNotification(false)}
//                 className="text-gray-400 hover:text-white"
//               >
//                 <X size={18} />
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Buy for Downline Toggle - DISABLE if downline activation is blocked */}
//       <div className="mb-8 card-glow p-6 bg-gray-800/50 rounded-xl">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-4">
//             <Users className="text-3xl text-primary" />
//             <div>
//               <h2 className="text-2xl font-bold text-white">Buy for Downline</h2>
//               <p className="text-gray-400">Purchase package for any downline member (up to 10 levels deep)</p>
//             </div>
//           </div>
//           {currentUserBlockStatus.downlineActivationStatus === 'disabled' ? (
//             <div className="px-6 py-3 bg-gray-700 rounded-full text-red-400 font-bold border border-red-500/30">
//               BLOCKED BY ADMIN
//             </div>
//           ) : (
//             <button
//               onClick={() => setIsBuyingForDownline(!isBuyingForDownline)}
//               className={`relative inline-flex items-center h-12 rounded-full w-24 transition-colors ${isBuyingForDownline ? 'bg-primary' : 'bg-gray-700'}`}
//               disabled={currentUserBlockStatus.downlineActivationStatus === 'disabled'}
//             >
//               <span className={`inline-block w-10 h-10 transform bg-white rounded-full transition-transform ${isBuyingForDownline ? 'translate-x-12' : 'translate-x-2'}`} />
//             </button>
//           )}
//         </div>

//         {isBuyingForDownline && (
//           <div className="mt-6 p-4 bg-primary/10 border border-primary/30 rounded-xl">
//             <h3 className="text-lg font-bold text-primary mb-3">Select Downline Member (Up to 10 Levels)</h3>
            
//             <div className="mb-4">
//               <button
//                 onClick={() => setShowDownlineSearch(!showDownlineSearch)}
//                 className="px-4 py-2 bg-gray-700 rounded-lg text-white hover:bg-gray-600 flex items-center gap-2"
//               >
//                 <Search size={16} />
//                 {showDownlineSearch ? 'Hide Search' : 'Search by User ID'}
//               </button>
              
//               {showDownlineSearch && (
//                 <div className="mt-3 flex gap-2">
//                   <input
//                     type="text"
//                     value={searchDownlineId}
//                     onChange={(e) => setSearchDownlineId(e.target.value)}
//                     placeholder="Enter User ID"
//                     className="flex-1 bg-gray-900 border border-primary/50 rounded-xl p-3 text-white"
//                   />
//                   <button
//                     onClick={searchDownline}
//                     className="px-4 py-2 bg-primary rounded-lg text-white hover:bg-primary/80"
//                   >
//                     Search
//                   </button>
//                 </div>
//               )}
//             </div>

//             {downlineList.length > 0 ? (
//               <div>
//                 <div className="mb-2 text-sm text-gray-400">
//                   Found {downlineList.length} downlines (up to 10 levels)
//                   <span className="ml-2 text-red-400">
//                     {downlineList.filter(d => !d.canReceivePackage).length} cannot receive packages
//                   </span>
//                 </div>
//                 <select
//                   value={selectedDownline}
//                   onChange={(e) => {
//                     const selected = downlineList.find(r => r.userId === e.target.value);
//                     setSelectedDownline(e.target.value);
//                     setSelectedDownlineName(selected?.name || '');
//                   }}
//                   className="w-full bg-gray-900 border border-primary/50 rounded-xl p-4 text-white mb-3"
//                 >
//                   <option value="" className="text-gray-400">Select downline member...</option>
//                   {downlineList.map(r => (
//                     <option 
//                       key={r.userId} 
//                       value={r.userId} 
//                       className={`${!r.canReceivePackage ? 'text-red-400' : 'text-white'}`}
//                       disabled={!r.canReceivePackage}
//                     >
//                       {r.name} ({r.levelLabel}) - ID: {r.sponsorId}
//                       {!r.canReceivePackage && ' [CANNOT RECEIVE]'}
//                     </option>
//                   ))}
//                 </select>
//                 {selectedDownline && (() => {
//                   const downline = downlineList.find(r => r.userId === selectedDownline);
//                   if (!downline) return null;
                  
//                   return (
//                     <div className="p-3 bg-gray-900/50 rounded-lg">
//                       <p className={`text-sm ${!downline.canReceivePackage ? 'text-red-400' : 'text-green-400'}`}>
//                         Selected: <span className="font-bold">{downline.name}</span>
//                         {!downline.canReceivePackage && ' (CANNOT RECEIVE PACKAGES)'}
//                       </p>
//                       {downline.blockReasons && downline.blockReasons.length > 0 && (
//                         <div className="mt-2">
//                           <p className="text-xs text-red-300">Block Reasons:</p>
//                           <ul className="text-xs text-gray-400 mt-1">
//                             {downline.blockReasons.map((reason, idx) => (
//                               <li key={idx}>• {reason}</li>
//                             ))}
//                           </ul>
//                         </div>
//                       )}
//                       {renderStatusBadges(downline)}
//                     </div>
//                   );
//                 })()}
//               </div>
//             ) : (
//               <p className="text-center text-gray-400 py-4">No downline members found</p>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Wallet Selection */}
//       <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-6">
//         <div className={`card-glow p-6 ${selectedWallet === 'aurum' ? 'border-primary bg-primary/10' : 'bg-gray-800/50'}`}>
//           <button onClick={() => setSelectedWallet('aurum')} className="w-full text-left">
//             <div className="flex justify-between items-center mb-4">
//               <Wallet className="text-3xl text-primary" />
//               {selectedWallet === 'aurum' && <Check className="text-green-400" />}
//             </div>
//             <h3 className="text-xl font-bold text-white">Aerovolt Wallet</h3>
//             <p className="text-gray-400 text-sm mb-2">Investment wallet</p>
//             <p className="text-3xl font-bold text-white">${walletBalances.aurum.toFixed(2)}</p>
//           </button>
//         </div>

//         <div className={`card-glow p-6 ${selectedWallet === 'fund' ? 'border-green-500 bg-green-500/10' : 'bg-gray-800/50'}`}>
//           <button onClick={() => setSelectedWallet('fund')} className="w-full text-left">
//             <div className="flex justify-between items-center mb-4">
//               <Wallet className="text-3xl text-green-400" />
//               {selectedWallet === 'fund' && <Check className="text-green-400" />}
//             </div>
//             <h3 className="text-xl font-bold text-white">AV PAY Wallet</h3>
//             <p className="text-green-400 text-sm mb-2">Deposit wallet</p>
//             <p className="text-3xl font-bold text-white">${walletBalances.fund.toFixed(2)}</p>
//           </button>
//         </div>
//       </div>

//       {/* NEW: AV PAY Wallet Transactions History */}
//       <div className="mb-8 card-glow p-6 bg-gray-800/50 rounded-xl">
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-3">
//             <History className="text-green-400" size={24} />
//             <h2 className="text-2xl font-bold text-white">AV PAY Wallet Transactions</h2>
//           </div>
//           <button
//             onClick={() => setShowFundHistory(!showFundHistory)}
//             className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-white flex items-center gap-2"
//           >
//             {showFundHistory ? 'Hide' : 'Show'} History
//             <Clock size={16} />
//           </button>
//         </div>

//         {/* Fund Wallet Stats */}
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
//           <div className="bg-gray-900/50 p-3 rounded-lg">
//             <div className="text-gray-400 text-xs">Total Completed</div>
//             <div className="text-lg font-bold text-green-400">{formatCurrency(fundStats.totalAdded)}</div>
//           </div>
//           <div className="bg-gray-900/50 p-3 rounded-lg">
//             <div className="text-gray-400 text-xs">Total Pending</div>
//             <div className="text-lg font-bold text-yellow-400">{formatCurrency(fundStats.totalPending)}</div>
//           </div>
//           <div className="bg-gray-900/50 p-3 rounded-lg">
//             <div className="text-gray-400 text-xs">Completed</div>
//             <div className="text-lg font-bold text-blue-400">{fundStats.count}</div>
//           </div>
//           <div className="bg-gray-900/50 p-3 rounded-lg">
//             <div className="text-gray-400 text-xs">Pending</div>
//             <div className="text-lg font-bold text-yellow-400">{fundStats.pendingCount}</div>
//           </div>
//         </div>

//         {showFundHistory && (
//           <div className="mt-4">
//             {loadingTransactions ? (
//               <div className="flex justify-center py-8">
//                 <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-green-400"></div>
//               </div>
//             ) : fundTransactions.length > 0 ? (
//               <div className="space-y-3 max-h-96 overflow-y-auto pr-2">
//                 {fundTransactions.map((tx) => (
//                   <div 
//                     key={tx.id} 
//                     className={`p-4 bg-gray-900/50 rounded-lg border-l-4 ${
//                       tx.isCompleted ? 'border-green-500' : 'border-yellow-500'
//                     }`}
//                   >
//                     <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
//                       <div className="flex-1">
//                         <div className="flex items-center gap-2 mb-2">
//                           <span className={`text-lg font-bold ${
//                             tx.isCompleted ? 'text-green-400' : 'text-yellow-400'
//                           }`}>
//                             {formatCurrency(tx.amount)}
//                           </span>
//                           {getStatusBadge(tx.status)}
//                           {tx.source === 'AUSTRAGRID' && (
//                             <span className="text-xs bg-purple-500/20 text-purple-400 px-2 py-1 rounded">
//                               AUSTRAGRID
//                             </span>
//                           )}
//                         </div>
//                         <p className="text-gray-300 text-sm mb-1">{tx.description}</p>
//                         <div className="flex flex-wrap items-center gap-3 text-xs text-gray-400">
//                           <span className="flex items-center gap-1">
//                             <CreditCard size={12} />
//                             {tx.paymentMethod}
//                           </span>
//                           <span className="flex items-center gap-1">
//                             <Calendar size={12} />
//                             {formatDate(tx.timestamp)}
//                           </span>
//                           {tx.network && (
//                             <span className="text-gray-500">{tx.network}</span>
//                           )}
//                         </div>
//                       </div>
//                       <div className="md:text-right">
//                         <div className="grid grid-cols-2 md:grid-cols-1 gap-2">
//                           <div>
//                             <div className="text-gray-500 text-xs">Before</div>
//                             <div className="text-gray-400 text-sm">{formatCurrency(tx.previousBalance)}</div>
//                           </div>
//                           <div>
//                             <div className="text-gray-500 text-xs">After</div>
//                             <div className={`text-sm font-bold ${
//                               tx.isCompleted ? 'text-green-400' : 'text-gray-400'
//                             }`}>
//                               {formatCurrency(tx.newBalance)}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-8 text-gray-400">
//                 No AV PAY wallet transactions found
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {activationRuleLoaded && activationBonusRule.enabled && (
//         <div className="mb-6">
//           <div className="card-glow p-4 md:p-5 bg-gradient-to-r from-emerald-500/10 to-blue-500/10 border border-emerald-500/30 rounded-xl">
//             <div className="flex items-center gap-3 mb-2">
//               <Gift className="text-emerald-400" size={20} />
//               <h3 className="text-white font-bold text-base md:text-lg">
//                 Activation Bonus
//               </h3>
//             </div>
//             <p className="text-sm md:text-base text-gray-200">
//               <span className="font-semibold text-emerald-300">
//                 Activate any {activationBonusRule.requiredPackages} packages
//               </span>{' '}
//               in{' '}
//               <span className="font-semibold text-emerald-300">
//                 {activationBonusRule.windowDays} days
//               </span>{' '}
//               and get{' '}
//               <span className="font-bold text-emerald-400">
//                 ${activationBonusRule.bonusAmount}
//               </span>{' '}
//               added to your{' '}
//               <span className="font-semibold text-blue-300">AV Power Wallet</span>.
//             </p>
//           </div>
//         </div>
//       )}

//       {/* Package Selection */}
//       <div className="mb-8">
//         <h2 className="text-2xl font-bold text-white mb-6">Select Package</h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {packages.map(pkg => {
//             const energyPercent = pkg.energyWallet || 4;
            
//             return (
//               <button
//                 key={pkg.id}
//                 onClick={() => {
//                   setSelectedPackage(pkg.id);
//                   setAmount(pkg.minInvestment.toString());
//                 }}
//                 className={`card-glow p-6 text-left transition-all ${selectedPackage === pkg.id ? 'border-primary bg-primary/10' : 'bg-gray-800/50 hover:bg-gray-700/50'}`}
//               >
//                 <h3 className="text-xl font-bold text-white mb-2">{pkg.name}</h3>
//                 <p className="text-gray-400 text-sm mb-4">{pkg.description || 'Investment Package'}</p>
                
//                 <div className="space-y-2 mb-4">
//                   <div className="flex justify-between">
//                     <span className="text-gray-300">Investment:</span>
//                     <span className="text-primary font-bold">
//                       ${pkg.minInvestment} - ${pkg.maxInvestment}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-300">Daily ROI:</span>
//                     <span className="text-green-400 font-bold">{pkg.dailyRoi}%</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-300">Commission Levels:</span>
//                     <span className="text-blue-400">5 levels</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-300">Commission Rates:</span>
//                     <span className="text-blue-400 text-sm">{pkg.referralLevels?.join('/')}%</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-300">Energy to Upline:</span>
//                     <span className="text-blue-400 text-sm">{energyPercent}% from ROI</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-300">Commission Rule:</span>
//                     <span className="text-green-400 text-sm">Active & Not Blocked uplines only</span>
//                   </div>
//                 </div>

//                 <div className="mt-2">
//                   <div className={`w-full text-center py-2 rounded-lg font-semibold ${selectedPackage === pkg.id ? 'bg-primary/20 text-primary border border-primary/40' : 'bg-gray-700/60 text-white border border-gray-600/60'}`}>
//                     {selectedPackage === pkg.id ? 'Selected Package' : 'Select Package'}
//                   </div>
//                 </div>
                
//                 {selectedPackage === pkg.id && (
//                   <div className="mt-4 p-3 bg-primary/10 rounded-lg">
//                     <div className="flex items-center gap-2">
//                       <Check className="text-primary" size={16} />
//                       <span className="text-primary text-sm">Selected</span>
//                     </div>
//                   </div>
//                 )}
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* Selected Package Details */}
//       {selectedPkg && (
//         <div className="card-glow p-8 mb-10 bg-gray-800/50 rounded-xl">
//           <h2 className="text-3xl font-bold text-white mb-6">{selectedPkg.name}</h2>
          
//           <div className="mb-8">
//             <label className="block text-white font-medium mb-3">Investment Amount ($)</label>
//             <input
//               type="number"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               className="w-full bg-gray-900 border border-gray-700 rounded-xl px-6 py-4 text-2xl font-bold text-white text-center"
//               min={selectedPkg.minInvestment}
//               max={selectedPkg.maxInvestment === 'Unlimited' ? undefined : selectedPkg.maxInvestment}
//             />
//             <div className="flex gap-3 mt-4">
//               <button 
//                 onClick={() => setAmount(selectedPkg.minInvestment.toString())}
//                 className="px-4 py-2 bg-gray-700 rounded-lg text-white hover:bg-gray-600"
//               >
//                 Min (${selectedPkg.minInvestment})
//               </button>
//               {selectedPkg.maxInvestment !== 'Unlimited' && (
//                 <button 
//                   onClick={() => setAmount(selectedPkg.maxInvestment.toString())}
//                   className="px-4 py-2 bg-gray-700 rounded-lg text-white hover:bg-gray-600"
//                 >
//                   Max (${selectedPkg.maxInvestment})
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Action Button */}
//           <div className="text-center">
//             <button
//               onClick={showConfirmation}
//               disabled={
//                 !amount || 
//                 parseFloat(amount) < selectedPkg.minInvestment || 
//                 (selectedPkg.maxInvestment !== 'Unlimited' && parseFloat(amount) > selectedPkg.maxInvestment) ||
//                 parseFloat(amount) > walletBalances[selectedWallet] ||
//                 (isBuyingForDownline && !selectedDownline) ||
//                 (isBuyingForDownline && currentUserBlockStatus.downlineActivationStatus === 'disabled')
//               }
//               className="btn-electric py-4 px-16 text-xl disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {isBuyingForDownline ? 'Gift Package' : 'Activate Package'}
//             </button>
//           </div>
//         </div>
//       )}

//       {showScratchDialog && (
//         <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[60] p-4">
//           <div className="w-full max-w-md rounded-xl border border-yellow-500/40 bg-gradient-to-br from-yellow-900/30 via-[#161E2D] to-emerald-900/30 shadow-2xl">
//             <div className="p-6">
//               <div className="flex items-center gap-2 mb-3">
//                 <Gift className="text-yellow-300" size={22} />
//                 <h3 className="text-xl font-bold text-white">Package Scratch Card</h3>
//               </div>
//               <p className="text-gray-200 text-sm mb-4">
//                 Package activated successfully. Scratch now to get extra fund bonus. Minimum reward: ${PACKAGE_SCRATCH_MIN_REWARD}.
//               </p>
//               <div className="rounded-lg border border-dashed border-yellow-300/60 bg-black/20 p-5 text-center mb-4">
//                 <div className="text-xs uppercase tracking-wider text-yellow-200/90 mb-1">Hidden Reward</div>
//                 <div className="text-2xl font-bold text-yellow-300">$ {scratchRewardAmount.toFixed(2)}</div>
//               </div>
//               <button
//                 onClick={handlePackageScratchClaim}
//                 disabled={scratchLoading}
//                 className="w-full py-3 rounded-lg bg-yellow-500 hover:bg-yellow-400 text-black font-bold transition disabled:opacity-60 disabled:cursor-not-allowed"
//               >
//                 {scratchLoading ? 'Claiming Reward...' : 'Scratch & Claim Reward'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirmation Dialog */}
//       <Dialog 
//         isOpen={showConfirmDialog} 
//         onClose={() => !isProcessing && setShowConfirmDialog(false)}
//         title="Confirm Package Purchase"
//       >
//         {confirmData && (
//           <div className="space-y-4">
//             <div className="text-center mb-6">
//               <div className="text-4xl font-bold text-primary mb-2">{confirmData.package.name}</div>
//               <div className="text-gray-300">Package Details</div>
//             </div>
            
//             <div className="bg-gray-800/50 rounded-xl p-4">
//               <div className="space-y-3">
//                 <div className="flex justify-between">
//                   <span className="text-gray-300">For:</span>
//                   <span className="text-white font-bold">
//                     {confirmData.isForDownline ? confirmData.targetUserName : 'Yourself'}
//                   </span>
//                 </div>
                
//                 <div className="flex justify-between">
//                   <span className="text-gray-300">Investment:</span>
//                   <span className="text-white font-bold">${confirmData.amount.toFixed(2)}</span>
//                 </div>
                
//                 <div className="flex justify-between border-t border-gray-700 pt-3">
//                   <span className="text-gray-300 text-lg">Total Value:</span>
//                   <span className="text-2xl text-primary font-bold">${confirmData.totalPackageValue.toFixed(2)}</span>
//                 </div>
                
//                 <div className="flex justify-between">
//                   <span className="text-gray-300">Daily ROI ({confirmData.package.dailyRoi}%):</span>
//                   <span className="text-green-400 font-bold">${confirmData.dailyROIAmount.toFixed(2)}/day</span>
//                 </div>
                
//                 <div className="flex justify-between">
//                   <span className="text-gray-300">Wallet Used:</span>
//                   <span className="text-yellow-400 font-bold">{confirmData.walletUsed}</span>
//                 </div>
//               </div>
//             </div>
            
//             {/* Commission Calculation */}
//             <div className="bg-gray-800/30 rounded-xl p-4">
//               <h4 className="text-white font-bold mb-2">Your Commission (If Active & Not Blocked):</h4>
//               <div className="grid grid-cols-5 gap-2 text-center">
//                 {confirmData.yourCommissionLevels?.map((percent, index) => (
//                   <div key={index} className="bg-gray-900/50 p-2 rounded">
//                     <div className="text-xs text-gray-400">Level {index + 1}</div>
//                     <div className="text-green-400 font-bold">{percent}%</div>
//                     <div className="text-xs text-white">
//                       ${((confirmData.totalPackageValue * percent) / 100).toFixed(2)}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <p className="text-xs text-gray-400 mt-2">*Commission checks: Active package + No login block + No level income block</p>
//             </div>
            
//             {/* Energy Wallet Information */}
//             <div className={`p-4 rounded-xl ${
//               confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked 
//                 ? 'bg-blue-500/10 border border-blue-500/30' 
//                 : 'bg-gray-800/50 border border-gray-700'
//             }`}>
//               <div className="flex items-center gap-2 mb-2">
//                 <Battery className={
//                   confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked 
//                     ? "text-blue-400" 
//                     : "text-gray-500"
//                 } size={20} />
//                 <h4 className={
//                   confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked 
//                     ? "text-blue-400 font-bold" 
//                     : "text-gray-500 font-bold"
//                 }>Energy Wallet Bonus</h4>
//                 {confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked ? (
//                   <span className="ml-auto text-xs bg-green-500/20 text-green-400 px-2 py-1 rounded">Active Upline</span>
//                 ) : confirmData.isDirectUplineBlocked ? (
//                   <span className="ml-auto text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded">Blocked Upline</span>
//                 ) : confirmData.isDirectUplineLevelIncomeBlocked ? (
//                   <span className="ml-auto text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded">Commission Blocked</span>
//                 ) : (
//                   <span className="ml-auto text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded">Inactive Upline</span>
//                 )}
//               </div>
              
//               {confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked ? (
//                 <>
//                   <p className="text-gray-300 text-sm">
//                     Direct upline is <span className="text-green-400 font-bold">ACTIVE & NOT BLOCKED</span> and will receive:
//                   </p>
//                   <div className="mt-2 p-3 bg-blue-500/20 rounded-lg">
//                     <div className="text-center">
//                       <div className="text-2xl font-bold text-blue-300">${confirmData.dailyEnergyAmount.toFixed(2)}/day</div>
//                       <div className="text-sm text-blue-200">Energy Wallet Credit</div>
//                     </div>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <p className="text-gray-300 text-sm">
//                     Direct upline is {confirmData.isDirectUplineBlocked ? 
//                     <span className="text-red-400 font-bold">BLOCKED</span> : 
//                     confirmData.isDirectUplineLevelIncomeBlocked ?
//                     <span className="text-red-400 font-bold">COMMISSION BLOCKED</span> :
//                     <span className="text-red-400 font-bold">INACTIVE</span>} and will <span className="text-red-400 font-bold">NOT</span> receive energy wallet.
//                   </p>
//                 </>
//               )}
//             </div>
            
//             {/* Block Status Summary */}
//             <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4">
//               <div className="flex items-center gap-2 mb-2">
//                 <Shield className="text-yellow-400" size={20} />
//                 <h4 className="text-yellow-400 font-bold">Complete Block Check</h4>
//               </div>
              
//               <div className="space-y-2">
//                 <div className="flex items-center justify-between">
//                   <span className="text-gray-300 text-sm">Your Status:</span>
//                   {currentUserBlockStatus.downlineActivationStatus === 'disabled' ? (
//                     <span className="text-red-400 text-sm font-medium">✗ Downline Activation BLOCKED</span>
//                   ) : (
//                     <span className="text-green-400 text-sm font-medium">✓ Purchase Allowed</span>
//                   )}
//                 </div>
                
//                 {confirmData.isForDownline && (
//                   <div className="flex items-center justify-between">
//                     <span className="text-gray-300 text-sm">Target User:</span>
//                     {confirmData.targetBlockStatus.canReceivePackage ? (
//                       <span className="text-green-400 text-sm font-medium">✓ Can Receive</span>
//                     ) : (
//                       <span className="text-red-400 text-sm font-medium">✗ Cannot Receive</span>
//                     )}
//                   </div>
//                 )}
                
//                 <div className="flex items-center justify-between">
//                   <span className="text-gray-300 text-sm">Direct Upline:</span>
//                   {confirmData.isDirectUplineBlocked ? (
//                     <span className="text-red-400 text-sm font-medium">✗ Blocked</span>
//                   ) : confirmData.isDirectUplineLevelIncomeBlocked ? (
//                     <span className="text-red-400 text-sm font-medium">✗ Commission Blocked</span>
//                   ) : confirmData.isDirectUplineActive ? (
//                     <span className="text-green-400 text-sm font-medium">✓ Active & Eligible</span>
//                   ) : (
//                     <span className="text-gray-400 text-sm font-medium">✗ Inactive</span>
//                   )}
//                 </div>
                
//                 <div className="mt-2 pt-2 border-t border-yellow-500/20">
//                   <p className="text-xs text-gray-400">
//                     System checks downline activation and login blocks. Blocked users cannot receive packages.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
        
//         <div className="flex gap-4 mt-8">
//           <button
//             onClick={() => setShowConfirmDialog(false)}
//             disabled={isProcessing}
//             className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl text-white font-bold transition-colors"
//           >
//             Cancel
//           </button>
//           <div className="flex-1 relative">
//             <button
//               onClick={handlePurchase}
//               disabled={
//                 isProcessing || 
//                 (isBuyingForDownline && currentUserBlockStatus.downlineActivationStatus === 'disabled') ||
//                 (confirmData?.isForDownline && !confirmData?.targetBlockStatus?.canReceivePackage)
//               }
//               className={`w-full py-3 rounded-xl text-white font-bold transition-colors ${
//                 isProcessing 
//                   ? 'bg-primary/50 cursor-not-allowed' 
//                   : 'bg-primary hover:bg-primary/80'
//               }`}
//             >
//               {isProcessing ? 'Processing...' : 'Confirm Purchase'}
//             </button>
//           </div>
//         </div>
//       </Dialog>

//       {/* Error Dialog */}
//       <Dialog 
//         isOpen={showErrorDialog} 
//         onClose={() => setShowErrorDialog(false)}
//         title="Error"
//       >
//         <div className="text-center">
//           <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
//             <AlertCircle className="text-red-400" size={32} />
//           </div>
//           <p className="text-white text-lg mb-6">{errorMessage}</p>
//           <button
//             onClick={() => setShowErrorDialog(false)}
//             className="w-full py-3 bg-red-500 hover:bg-red-600 rounded-xl text-white font-bold transition-colors"
//           >
//             OK
//           </button>
//         </div>
//       </Dialog>
//     </div>
//   );
// };

// export default ActivatePackage;

import React, { useState, useEffect } from 'react';
import { database, ref, get, set, update, query, orderByChild, equalTo, onValue } from '../../firebase';
import { Wallet, Users, TrendingUp, Gift, AlertCircle, Check, Battery, X, Package, Info, Search, Shield, AlertTriangle, DollarSign, History, Clock, ArrowUpRight, Calendar, CreditCard, Award, ChevronRight, Zap, BarChart3, Layers, Star, Gem, Coins, Sparkles, Target, Trophy, ChevronDown } from 'lucide-react';
import { saveScratchHistory, fetchScratchMinRewards } from '../../utils/scratchCardService';

const DEFAULT_ACTIVATION_BONUS_RULE = {
  enabled: true,
  requiredPackages: 3,
  windowDays: 45,
  bonusAmount: 15,
  wallet: 'working'
};

const ActivatePackage = () => {
  const [selectedWallet, setSelectedWallet] = useState('aurum');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [amount, setAmount] = useState('');
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // User info
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');
  const [userSponsorId, setUserSponsorId] = useState('');
  const [userDbKey, setUserDbKey] = useState('');
  const [userRegistrationDate, setUserRegistrationDate] = useState('');
  const [userUplineId, setUserUplineId] = useState('');
  
  // Get user's active package for commission calculation
  const [userActivePackage, setUserActivePackage] = useState(null);
  
  // Wallet balances
  const [walletBalances, setWalletBalances] = useState({
    aurum: 0,
    fund: 0
  });
  const [activationBonusRule, setActivationBonusRule] = useState(DEFAULT_ACTIVATION_BONUS_RULE);
  const [activationRuleLoaded, setActivationRuleLoaded] = useState(false);

  // NEW: Fund Wallet Transactions
  const [fundTransactions, setFundTransactions] = useState([]);
  const [loadingTransactions, setLoadingTransactions] = useState(false);
  const [showFundHistory, setShowFundHistory] = useState(false);
  const [fundStats, setFundStats] = useState({
    totalAdded: 0,
    totalPending: 0,
    count: 0,
    pendingCount: 0
  });

  // For buying for downline
  const [isBuyingForDownline, setIsBuyingForDownline] = useState(false);
  const [selectedDownline, setSelectedDownline] = useState('');
  const [selectedDownlineName, setSelectedDownlineName] = useState('');
  const [downlineList, setDownlineList] = useState([]);
  const [showDownlineSearch, setShowDownlineSearch] = useState(false);
  const [searchDownlineId, setSearchDownlineId] = useState('');

  // Dialog states
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmData, setConfirmData] = useState(null);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // New state for purchase status
  const [isProcessing, setIsProcessing] = useState(false);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showScratchDialog, setShowScratchDialog] = useState(false);
  const [scratchRewardAmount, setScratchRewardAmount] = useState(0);
  const [scratchReferenceId, setScratchReferenceId] = useState('');
  const [scratchLoading, setScratchLoading] = useState(false);
  const [packageScratchMinReward, setPackageScratchMinReward] = useState(2);
  const PACKAGE_SCRATCH_MIN_REWARD = packageScratchMinReward;

  // Block status listeners
  const [blockStatusListeners, setBlockStatusListeners] = useState([]);
  
  // Store current user's block status
  const [currentUserBlockStatus, setCurrentUserBlockStatus] = useState({
    downlineActivationStatus: 'enabled',
    loginStatus: 'active',
    isBlocked: false
  });

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    const storedUserName = localStorage.getItem('userName');
    const storedSponsorId = localStorage.getItem('userSponsorId') || storedUserId;
    const storedDbKey = localStorage.getItem('dbKey');
    const storedUplineId = localStorage.getItem('userUplineId');
    const storedRegistrationDate = localStorage.getItem('registrationDate');

    if (storedUserId) {
      setUserId(storedUserId);
      setUserSponsorId(storedSponsorId);
      setUserDbKey(storedDbKey || storedUserId);
      setUserRegistrationDate(storedRegistrationDate || '2026-02-06'); // Default date
      setUserUplineId(storedUplineId || '');
      fetchUserBalances(storedDbKey || storedUserId, storedRegistrationDate);
      fetchUserActivePackage(storedDbKey || storedUserId, storedRegistrationDate);
      
      // NEW: Fetch fund wallet transactions
      fetchFundWalletTransactions(storedUserId, storedDbKey);
      
      // Start listening for block status changes
      setupBlockStatusListeners(storedDbKey || storedUserId, storedRegistrationDate);
    }
    if (storedUserName) setUserName(storedUserName);

    fetchPackages();
    fetchActivationBonusRule();
    fetchScratchSettings();

    // Cleanup listeners on unmount
    return () => {
      blockStatusListeners.forEach(unsubscribe => unsubscribe());
    };
  }, []);

  const fetchScratchSettings = async () => {
    try {
      const settings = await fetchScratchMinRewards();
      setPackageScratchMinReward(Number(settings.package_activation) || 2);
    } catch (error) {
      console.error('Error fetching package scratch minimum settings:', error);
    }
  };

  // NEW: Fetch Fund Wallet Transactions from UserFundTransactions
  const fetchFundWalletTransactions = async (userId, dbKey) => {
    setLoadingTransactions(true);
    try {
      const txRef = ref(database, 'UserFundTransactions');
      const snapshot = await get(txRef);
      
      const transactionsList = [];
      let totalAdded = 0;
      let totalPending = 0;
      let count = 0;
      let pendingCount = 0;
      
      if (snapshot.exists()) {
        const data = snapshot.val();
        
        // Search through all dates
        Object.entries(data).forEach(([date, dateGroup]) => {
          Object.entries(dateGroup).forEach(([userKey, userGroup]) => {
            Object.entries(userGroup).forEach(([txId, tx]) => {
              // Check if this transaction belongs to current user
              if (tx.userId === userId || tx.memberId === dbKey || userKey === dbKey) {
                const isCompleted = tx.status === 'completed' || tx.status === 'success';
                
                const transaction = {
                  id: txId,
                  date: date,
                  amount: parseFloat(tx.amount) || 0,
                  previousBalance: parseFloat(tx.previousFundBalance) || 0,
                  newBalance: parseFloat(tx.fundBalance) || 0,
                  paymentMethod: tx.displayCurrency || tx.currency || 'Crypto',
                  status: tx.status || 'pending',
                  timestamp: tx.timestampFormatted || tx.timestamp || date,
                  description: tx.reason || tx.description || 'Fund Addition',
                  source: tx.source || 'User',
                  network: tx.network || '',
                  currency: tx.currency || '',
                  transactionId: tx.transactionId || txId,
                  isCompleted: isCompleted
                };
                
                transactionsList.push(transaction);
                
                // Only count completed transactions in totals
                if (isCompleted) {
                  totalAdded += transaction.amount;
                  count++;
                } else {
                  totalPending += transaction.amount;
                  pendingCount++;
                }
              }
            });
          });
        });
      }
      
      // Sort by date (newest first)
      transactionsList.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      
      setFundTransactions(transactionsList);
      setFundStats({
        totalAdded,
        totalPending,
        count,
        pendingCount
      });
      
    } catch (error) {
      console.error('Error fetching fund wallet transactions:', error);
    } finally {
      setLoadingTransactions(false);
    }
  };

  // Setup real-time listeners for block status
  const setupBlockStatusListeners = (dbKey, registrationDate) => {
    const listeners = [];
    
    // Listen to user's main block statuses
    const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
    const userListener = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        
        // Update current user block status
        setCurrentUserBlockStatus({
          downlineActivationStatus: userData.downlineActivationStatus || 'enabled',
          loginStatus: userData.loginStatus || 'active',
          isBlocked: userData.downlineActivationStatus === 'disabled' || 
                    userData.loginStatus === 'blocked'
        });
        
        console.log('User status updated:', {
          loginStatus: userData.loginStatus,
          roiStatus: userData.roiStatus,
          levelIncomeStatus: userData.levelIncomeStatus,
          withdrawalStatus: userData.withdrawalStatus,
          downlineActivationStatus: userData.downlineActivationStatus,
          internalTransferStatus: userData.internalTransferStatus
        });
      }
    });
    listeners.push(userListener);
    
    setBlockStatusListeners(listeners);
  };

  const showError = (message) => {
    setErrorMessage(message);
    setShowErrorDialog(true);
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setShowSuccessNotification(true);
    setTimeout(() => {
      setShowSuccessNotification(false);
    }, 5000);
  };

  const generateScratchReward = () => {
    return PACKAGE_SCRATCH_MIN_REWARD;
  };

  const creditPackageScratchToFund = async (rewardAmount, referenceId) => {
    try {
      const normalizedReward = Number(rewardAmount);
      if (!normalizedReward || normalizedReward <= 0) {
        return { success: false, error: 'Invalid scratch reward amount' };
      }

      if (!userRegistrationDate || !userDbKey) {
        return { success: false, error: 'User session not ready' };
      }

      const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
      const userSnapshot = await get(userRef);
      if (!userSnapshot.exists()) {
        return { success: false, error: 'User not found' };
      }

      const userData = userSnapshot.val() || {};
      const currentFund = userData.fund || {};
      const currentFundBalance = parseFloat(currentFund.balance) || 0;
      const currentFundTotal = parseFloat(currentFund.total) || 0;
      const currentFundCount = parseInt(currentFund.count, 10) || 0;

      const safeReference = String(referenceId || Date.now()).replace(/[^a-zA-Z0-9_-]/g, '_');
      const dateKey = new Date().toISOString().split('T')[0];
      const sponsorKey = userSponsorId || userId || 'unknown';
      const transactionId = `SCRATCH_PACKAGE_${safeReference}`;
      const txRef = ref(database, `UserFundTransactions/${dateKey}/${sponsorKey}/${transactionId}`);
      const existingTx = await get(txRef);
      if (existingTx.exists()) {
        return {
          success: true,
          alreadyCredited: true,
          rewardAmount: Number(existingTx.val()?.amount || normalizedReward)
        };
      }

      const newFundBalance = currentFundBalance + normalizedReward;
      const newFundTotal = currentFundTotal + normalizedReward;
      const newFundCount = currentFundCount + 1;

      await update(userRef, {
        'fund/balance': newFundBalance,
        'fund/total': newFundTotal,
        'fund/count': newFundCount,
        'fund/lastAmount': normalizedReward,
        'fund/lastDate': new Date().toISOString(),
        'fund/lastTransactionId': transactionId,
        'fund/lastTransactionType': 'Scratch Reward',
        'fund/lastTransactionWallet': 'Fund Wallet',
        'fund/lastTransactionSource': 'Scratch Card'
      });

      await set(txRef, {
        transactionId,
        timestamp: Date.now(),
        timestampFormatted: new Date().toISOString(),
        userId,
        userName,
        memberId: userDbKey,
        sponsorId: sponsorKey,
        amount: normalizedReward,
        type: 'scratch_reward',
        source: 'Scratch Card',
        description: 'Package activation scratch reward',
        wallet: 'Fund Wallet',
        previousFundBalance: currentFundBalance,
        fundBalance: newFundBalance,
        userAddedFund: newFundTotal,
        fundCount: newFundCount,
        status: 'completed',
        referenceId: referenceId || '',
        minimumReward: PACKAGE_SCRATCH_MIN_REWARD
      });

      try {
        await saveScratchHistory({
          dateKey,
          userId,
          userName,
          memberId: userDbKey,
          sponsorId: sponsorKey,
          amount: normalizedReward,
          source: 'Scratch Card',
          eventType: 'package_activation',
          description: 'Package activation scratch reward',
          wallet: 'Fund Wallet',
          referenceId: referenceId || '',
          minimumReward: PACKAGE_SCRATCH_MIN_REWARD,
          status: 'completed'
        });
      } catch (scratchHistoryError) {
        console.error('Error saving package scratch history:', scratchHistoryError);
      }

      localStorage.setItem('userBalance', String(newFundBalance));
      setWalletBalances(prev => ({ ...prev, fund: newFundBalance }));
      await fetchFundWalletTransactions(userId, userDbKey);

      return { success: true, rewardAmount: normalizedReward };
    } catch (error) {
      console.error('Error crediting package scratch reward:', error);
      return { success: false, error: error.message };
    }
  };

  const handlePackageScratchClaim = async () => {
    if (scratchLoading || !scratchRewardAmount) return;
    setScratchLoading(true);
    try {
      const result = await creditPackageScratchToFund(scratchRewardAmount, scratchReferenceId);
      if (result.success) {
        const creditedAmount = Number(result.rewardAmount || scratchRewardAmount);
        setShowScratchDialog(false);
        showSuccess(`Scratch reward claimed: $${creditedAmount.toFixed(2)} added to AV PAY wallet.`);
      } else {
        showError(result.error || 'Unable to claim scratch reward.');
      }
    } finally {
      setScratchLoading(false);
    }
  };

  // Fetch user balances with date-wise structure
  const fetchUserBalances = async (dbKey, registrationDate) => {
    try {
      const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
      const snapshot = await get(userRef);

      if (snapshot.exists()) {
        const userData = snapshot.val();
        setWalletBalances({
          aurum: parseFloat(userData.wallets?.aurum) || 0,
          fund: parseFloat(userData.fund?.balance) || 0
        });
        if (!userUplineId && userData.uplineSponsorId) {
          setUserUplineId(userData.uplineSponsorId);
        }
      }
    } catch (error) {
      console.error('Error fetching balances:', error);
    }
  };

  // Get user's active package for commission calculation with date-wise structure
  const fetchUserActivePackage = async (dbKey, registrationDate) => {
    try {
      const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
      const snapshot = await get(userRef);

      if (snapshot.exists()) {
        const userData = snapshot.val();
        const userPackages = userData.packages || [];
        
        const activePackage = userPackages
          .filter(pkg => pkg.status === 'active')
          .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))[0];
        
        setUserActivePackage(activePackage);
      }
    } catch (error) {
      console.error('Error fetching user active package:', error);
    }
  };

  const fetchPackages = async () => {
    try {
      const packagesRef = ref(database, 'Packages');
      const snapshot = await get(packagesRef);
      
      if (snapshot.exists()) {
        const packagesData = snapshot.val();
        const packagesArray = Object.entries(packagesData).map(([id, pkg]) => ({
          id,
          ...pkg,
          roiCreditDays: pkg.roiCreditDays || 5,
          workingDays: pkg.workingDays || 'Mon-Fri',
          durationDays: pkg.durationDays || 365,
          referralLevels: pkg.referralLevels || [0, 0, 0, 0, 0],
          energyWallet: pkg.energyWallet || 4,
        }));
        setPackages(packagesArray);
      }
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const recordWorkingWalletBonus = async ({
    targetUser,
    bonusAmount,
    previousBalance,
    newBalance,
    transactionId,
    description
  }) => {
    try {
      const dateKey = new Date().toISOString().split('T')[0];
      const sponsorKey = targetUser.sponsorId || targetUser.userId || 'unknown';
      const txRef = ref(database, `adminaddedhistory/${dateKey}/${sponsorKey}/${transactionId}`);
      await set(txRef, {
        transactionId,
        userId: targetUser.userId,
        memberId: targetUser.dbKey,
        sponsorId: targetUser.sponsorId || targetUser.userId,
        walletType: 'AV Power Wallet',
        transactionType: 'AV Power Wallet Credit',
        amount: bonusAmount,
        previousBalance,
        newBalance,
        description,
        date: new Date().toISOString(),
        source: 'Aerovolt'
      });
    } catch (error) {
      console.error('Error recording working wallet bonus:', error);
    }
  };

  const fetchActivationBonusRule = async () => {
    try {
      const ruleRef = ref(database, 'Packages/packageRules');
      const snapshot = await get(ruleRef);
      if (snapshot.exists()) {
        const data = snapshot.val() || {};
        setActivationBonusRule({
          enabled: data.enabled !== false,
          requiredPackages: parseInt(data.requiredPackages, 10) || DEFAULT_ACTIVATION_BONUS_RULE.requiredPackages,
          windowDays: parseInt(data.windowDays, 10) || DEFAULT_ACTIVATION_BONUS_RULE.windowDays,
          bonusAmount: parseFloat(data.bonusAmount) || DEFAULT_ACTIVATION_BONUS_RULE.bonusAmount,
          wallet: data.wallet || DEFAULT_ACTIVATION_BONUS_RULE.wallet
        });
      } else {
        setActivationBonusRule(DEFAULT_ACTIVATION_BONUS_RULE);
      }
    } catch (error) {
      console.error('Error fetching activation bonus rule:', error);
      setActivationBonusRule(DEFAULT_ACTIVATION_BONUS_RULE);
    } finally {
      setActivationRuleLoaded(true);
    }
  };

  // Get ALL downlines (up to 10 levels) with date-wise structure
  const fetchAllDownlines = async () => {
    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const usersByDate = snapshot.val();
        const allDownlines = [];
        
        // Function to recursively find downlines with date-wise structure
        const findDownlines = async (currentSponsorId, level = 1, maxLevel = 10) => {
          if (level > maxLevel) return;
          
          // Search through all date folders
          for (const date in usersByDate) {
            const users = usersByDate[date];
            
            for (const [key, user] of Object.entries(users)) {
              if (user.uplineSponsorId === currentSponsorId) {
                // Get complete block status for this user
                const blockStatus = await getCompleteBlockStatus(user.sponsorId || key, date, key);
                
                allDownlines.push({
                  dbKey: key,
                  userId: user.sponsorId || key,
                  name: user.name || 'Unknown',
                  sponsorId: user.sponsorId,
                  uplineSponsorId: user.uplineSponsorId || '',
                  registrationDate: date,
                  level: level,
                  levelLabel: level === 1 ? 'Direct' : `Level ${level}`,
                  // Complete block status
                  ...blockStatus
                });
                
                // Recursively find downlines of this downline
                await findDownlines(user.sponsorId, level + 1, maxLevel);
              }
            }
          }
        };
        
        // Start from current user's sponsor ID
        await findDownlines(userSponsorId, 1, 10);
        
        setDownlineList(allDownlines);
        console.log(`Found ${allDownlines.length} downlines up to 10 levels`);
      }
    } catch (error) {
      console.error('Error fetching all downlines:', error);
    }
  };

  // COMPLETE BLOCK STATUS CHECK - Checks ALL block locations
  const getCompleteBlockStatus = async (userId, registrationDate, dbKey) => {
    try {
      const status = {
        // User-level blocks
        loginStatus: 'active',
        roiStatus: 'active',
        levelIncomeStatus: 'active',
        withdrawalStatus: 'enabled',
        downlineActivationStatus: 'enabled',
        internalTransferStatus: 'enabled',
        
        // Package-level ROI block
        packageRoiStatus: 'active',
        
        // Level income collection block
        levelIncomeCollectionBlocked: false,
        
        // ROISchedule block
        roiScheduleBlocked: false,
        
        // Overall status
        isBlocked: false,
        isLevelIncomeBlocked: false,
        canReceivePackage: true, // Default true
        blockReasons: []
      };

      // 1. Check user-level statuses
      if (dbKey && registrationDate) {
        const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
        const userSnap = await get(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.val();
          
          // Get user statuses with defaults
          status.loginStatus = userData.loginStatus || 'active';
          status.roiStatus = userData.roiStatus || 'active';
          status.levelIncomeStatus = userData.levelIncomeStatus || 'active';
          status.withdrawalStatus = userData.withdrawalStatus || 'enabled';
          status.downlineActivationStatus = userData.downlineActivationStatus || 'enabled';
          status.internalTransferStatus = userData.internalTransferStatus || 'enabled';
          
          // Check if user can receive package
          // CRITICAL: User cannot receive package if login is blocked
          if (status.loginStatus === 'blocked') {
            status.isBlocked = true;
            status.canReceivePackage = false;
            status.blockReasons.push('Login blocked - cannot receive packages');
          }
          
          // User cannot receive package if downline activation is disabled (for admin blocks)
          if (status.downlineActivationStatus === 'disabled') {
            status.isBlocked = true;
            status.canReceivePackage = false;
            status.blockReasons.push('Downline activation blocked - cannot receive packages');
          }
          
          // Check other blocks for informational purposes
          if (status.roiStatus === 'blocked') {
            status.isBlocked = true;
            status.blockReasons.push('ROI blocked at user level');
          }
          if (status.levelIncomeStatus === 'blocked') {
            status.isLevelIncomeBlocked = true;
            status.blockReasons.push('Level income blocked at user level');
          }
        }
      }

      return status;
      
    } catch (error) {
      console.error('Error getting complete block status:', error);
      return {
        loginStatus: 'active',
        roiStatus: 'active',
        levelIncomeStatus: 'active',
        withdrawalStatus: 'enabled',
        downlineActivationStatus: 'enabled',
        internalTransferStatus: 'enabled',
        packageRoiStatus: 'active',
        levelIncomeCollectionBlocked: false,
        roiScheduleBlocked: false,
        isBlocked: false,
        canReceivePackage: true,
        isLevelIncomeBlocked: false,
        blockReasons: ['Error checking status']
      };
    }
  };

  // Check if user can purchase (buyer check)
  const canUserPurchase = async (userId, isForDownline = false) => {
    try {
      // Find user first
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      
      if (!snapshot.exists()) return { canPurchase: false, reason: 'User not found' };
      
      const usersByDate = snapshot.val();
      let userData = null;
      let userDbKey = '';
      let userRegistrationDate = '';
      
      // Search through all date folders
      for (const date in usersByDate) {
        const users = usersByDate[date];
        
        for (const [key, user] of Object.entries(users)) {
          if (user.sponsorId === userId || key === userId) {
            userData = user;
            userDbKey = key;
            userRegistrationDate = date;
            break;
          }
        }
        if (userData) break;
      }
      
      if (!userData) {
        return { canPurchase: false, reason: 'User not found' };
      }
      
      // 1. Check login status
      if (userData.loginStatus === 'blocked') {
        return { canPurchase: false, reason: 'Your account is blocked from login' };
      }
      
      // 2. CRITICAL: If buying for downline, check downline activation status
      if (isForDownline) {
        if (userData.downlineActivationStatus === 'disabled') {
          return { 
            canPurchase: false, 
            reason: 'You are BLOCKED from activating packages for downlines. Contact admin.' 
          };
        }
      }
      
      // 3. Check if user has active package (required for commissions)
      const userPackages = userData.packages || [];
      const hasActivePackage = userPackages.some(pkg => pkg && pkg.status === 'active');
      
      if (!hasActivePackage) {
        console.log('User has no active package - commissions may be affected');
      }
      
      // 4. Check level income status
      if (userData.levelIncomeStatus === 'blocked') {
        console.log('User has level income blocked - will not receive commissions');
      }
      
      return { 
        canPurchase: true, 
        reason: '',
        userData,
        dbKey: userDbKey,
        registrationDate: userRegistrationDate
      };
      
    } catch (error) {
      console.error('Error checking user purchase ability:', error);
      return { canPurchase: false, reason: 'Error checking user status' };
    }
  };

  // Check if target user can receive package
  const canUserReceivePackage = async (targetUserId) => {
    try {
      const status = await getCompleteBlockStatus(targetUserId);
      
      // CRITICAL: User cannot receive package if:
      // 1. Login is blocked
      // 2. Downline activation is disabled (for admin blocks on receiver)
      if (status.loginStatus === 'blocked') {
        return {
          canReceive: false,
          reason: 'Target user is blocked from login - cannot receive packages',
          blockStatus: status
        };
      }
      
      if (status.downlineActivationStatus === 'disabled') {
        return {
          canReceive: false,
          reason: 'Target user has downline activation blocked - cannot receive packages',
          blockStatus: status
        };
      }
      
      return {
        canReceive: true,
        reason: '',
        blockStatus: status
      };
      
    } catch (error) {
      console.error('Error checking user receive ability:', error);
      return { canReceive: false, reason: 'Error checking user status' };
    }
  };

  const searchDownline = async () => {
    if (!searchDownlineId.trim()) {
      showError('Please enter a user ID to search');
      return;
    }

    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const usersByDate = snapshot.val();
        let foundUser = null;
        let foundDbKey = '';
        let foundRegistrationDate = '';
        
        // Search through all date folders
        for (const date in usersByDate) {
          const users = usersByDate[date];
          
          for (const [key, user] of Object.entries(users)) {
            if (user.sponsorId === searchDownlineId || 
                key === searchDownlineId) {
              foundUser = user;
              foundDbKey = key;
              foundRegistrationDate = date;
              break;
            }
          }
          if (foundUser) break;
        }
        
        if (foundUser) {
          // Get complete block status
          const blockStatus = await getCompleteBlockStatus(foundUser.sponsorId, foundRegistrationDate, foundDbKey);
          
          // CRITICAL: Check if user can receive package
          if (!blockStatus.canReceivePackage) {
            showError(`User ${foundUser.name} cannot receive packages: ${blockStatus.blockReasons.join(', ')}`);
            return;
          }
          
          setSelectedDownline(foundUser.sponsorId);
          setSelectedDownlineName(foundUser.name);
          setShowDownlineSearch(false);
        } else {
          showError('User not found');
        }
      }
    } catch (error) {
      console.error('Error searching downline:', error);
      showError('Error searching user');
    }
  };

  useEffect(() => {
    if (isBuyingForDownline) {
      fetchAllDownlines();
    }
  }, [isBuyingForDownline]);

  const getPackageSequence = async (targetDbKey, targetRegistrationDate) => {
    try {
      const userRef = ref(database, `users/${targetRegistrationDate}/${targetDbKey}`);
      const snapshot = await get(userRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const packages = userData.packages || [];
        return packages.length + 1;
      }
      return 1;
    } catch (error) {
      console.error('Error getting package sequence:', error);
      return 1;
    }
  };

  // Check if a user is active (has at least one active package) with date-wise structure
  const isUserActive = (userData) => {
    const userPackages = userData.packages || [];
    return userPackages.some(pkg => pkg.status === 'active');
  };

  // Get upline chain with date-wise structure
  const getUplineChain = async (sponsorId, maxLevels = 5) => {
    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      
      if (!snapshot.exists()) return [];
      
      const usersByDate = snapshot.val();
      const uplineChain = [];
      
      // First find the user to get their upline
      let currentUplineId = '';
      let currentDbKey = '';
      let currentRegistrationDate = '';
      
      for (const date in usersByDate) {
        const users = usersByDate[date];
        for (const [dbKey, user] of Object.entries(users)) {
          if (user.sponsorId === sponsorId) {
            currentUplineId = user.uplineSponsorId;
            currentDbKey = dbKey;
            currentRegistrationDate = date;
            break;
          }
        }
        if (currentUplineId) break;
      }
      
      if (!currentUplineId) return [];
      
      let level = 1;
      
      while (currentUplineId && level <= maxLevels) {
        let uplineUser = null;
        let uplineDbKey = '';
        let uplineRegistrationDate = '';
        
        // Find upline in date-wise structure
        for (const date in usersByDate) {
          const users = usersByDate[date];
          for (const [dbKey, user] of Object.entries(users)) {
            if (user.sponsorId === currentUplineId) {
              uplineUser = user;
              uplineDbKey = dbKey;
              uplineRegistrationDate = date;
              break;
            }
          }
          if (uplineUser) break;
        }
        
        if (uplineUser) {
          // Get complete block status for this upline
          const blockStatus = await getCompleteBlockStatus(uplineUser.sponsorId, uplineRegistrationDate, uplineDbKey);
          
          // Check if upline is active
          const isActive = isUserActive(uplineUser);
          
          uplineChain.push({
            level: level,
            user: uplineUser,
            dbKey: uplineDbKey,
            registrationDate: uplineRegistrationDate,
            isActive: isActive,
            blockStatus: blockStatus,
            isBlocked: blockStatus.isBlocked,
            isLevelIncomeBlocked: blockStatus.levelIncomeStatus === 'blocked' || blockStatus.levelIncomeCollectionBlocked,
            isLoginBlocked: blockStatus.loginStatus === 'blocked',
            isROIBlocked: blockStatus.roiStatus === 'blocked' || blockStatus.packageRoiStatus === 'blocked' || blockStatus.roiScheduleBlocked
          });
          
          currentUplineId = uplineUser.uplineSponsorId;
          level++;
        } else {
          break;
        }
      }
      
      return uplineChain;
    } catch (error) {
      console.error('Error getting upline chain:', error);
      return [];
    }
  };

  // Get upline's commission percentages based on THEIR package with date-wise structure
  const getUplineCommissionPercentages = async (uplineDbKey, uplineRegistrationDate) => {
    try {
      const uplineRef = ref(database, `users/${uplineRegistrationDate}/${uplineDbKey}`);
      const snapshot = await get(uplineRef);
      
      if (snapshot.exists()) {
        const uplineData = snapshot.val();
        const uplinePackages = uplineData.packages || [];
        
        const uplineActivePackage = uplinePackages
          .filter(pkg => pkg.status === 'active')
          .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))[0];
        
        if (uplineActivePackage && uplineActivePackage.referralLevels) {
          return uplineActivePackage.referralLevels;
        }
      }
      
      return [9, 7, 4, 2, 1]; // Default Plan 1
    } catch (error) {
      console.error('Error getting upline commission percentages:', error);
      return [9, 7, 4, 2, 1];
    }
  };

const AUSTRALIA_TIMEZONE = "Asia/Dubai";

const getAustraliaDateParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: AUSTRALIA_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).formatToParts(date);

  const map = {};
  parts.forEach((p) => {
    if (p.type !== "literal") map[p.type] = p.value;
  });

  return {
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour: Number(map.hour),
    minute: Number(map.minute),
    second: Number(map.second)
  };
};

const getDateKeyFromParts = ({ year, month, day }) =>
  `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

const addDaysToDateKey = (dateKey, days) => {
  const [year, month, day] = dateKey.split("-").map(Number);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  utcDate.setUTCDate(utcDate.getUTCDate() + days);
  return `${utcDate.getUTCFullYear()}-${String(utcDate.getUTCMonth() + 1).padStart(2, "0")}-${String(utcDate.getUTCDate()).padStart(2, "0")}`;
};

const getDayFromDateKey = (dateKey) => {
  const [year, month, day] = dateKey.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day)).getUTCDay();
};

const normalizeWorkingDaysPattern = (workingDaysPattern) => {
  const raw = String(workingDaysPattern || '').trim().toLowerCase();
  if (!raw) return 'Mon-Fri';
  if (raw === 'mon-fri' || raw === 'monday - friday' || raw === 'monday-friday') return 'Mon-Fri';
  if (raw === 'mon-sat' || raw === 'monday - saturday' || raw === 'monday-saturday') return 'Mon-Sat';
  if (raw === 'all' || raw === 'daily' || raw === 'everyday') return 'All';
  return workingDaysPattern;
};

// Helper: Check if a day is a working day (using Dubai date key)
const isWorkingDay = (workingDaysPattern = "Mon-Fri", dateOrKey = new Date()) => {
  const normalizedPattern = normalizeWorkingDaysPattern(workingDaysPattern);
  const dateKey = typeof dateOrKey === "string"
    ? dateOrKey
    : getDateKeyFromParts(getAustraliaDateParts(dateOrKey));

  const day = getDayFromDateKey(dateKey); // 0 = Sunday

  if (normalizedPattern === "Mon-Fri") return day >= 1 && day <= 5;
  if (normalizedPattern === "Mon-Sat") return day >= 1 && day <= 6;
  if (normalizedPattern === "All") return true;
  return day >= 1 && day <= 5;
};

const getNextWorkingDayKey = (workingDaysPattern = "Mon-Fri", fromDateKey) => {
  const normalizedPattern = normalizeWorkingDaysPattern(workingDaysPattern);
  let nextKey = addDaysToDateKey(fromDateKey, 1);
  while (!isWorkingDay(normalizedPattern, nextKey)) {
    nextKey = addDaysToDateKey(nextKey, 1);
  }
  return nextKey;
};

const dateKeyToAESTMidnightIso = (dateKey) => {
  const [year, month, day] = dateKey.split("-").map(Number);
  const utcMillis = Date.UTC(year, month - 1, day, 0, 0, 0) - (4 * 60 * 60 * 1000);
  return new Date(utcMillis).toISOString();
};

const parseDateKeyToUtcDate = (dateKey) => {
  if (!dateKey) return null;
  const [year, month, day] = dateKey.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(Date.UTC(year, month - 1, day));
};

const isWithinActivationWindow = (purchaseDate, registrationDate, windowDays) => {
  if (!purchaseDate || !registrationDate) return false;
  const startDate = parseDateKeyToUtcDate(registrationDate);
  if (!startDate) return false;
  const endDate = new Date(startDate);
  endDate.setUTCDate(endDate.getUTCDate() + windowDays);
  const purchase = new Date(purchaseDate);
  return purchase >= startDate && purchase <= endDate;
};

const countEligiblePackagesWithinWindow = (packages, registrationDate, windowDays) => {
  if (!Array.isArray(packages)) return 0;
  return packages.filter((pkg) => {
    if (!pkg) return false;
    const status = String(pkg.status || 'active').toLowerCase();
    if (status !== 'active' && status !== 'completed') return false;
    const purchaseDate = pkg.purchaseDate || pkg.date || pkg.purchaseTimestamp;
    return isWithinActivationWindow(purchaseDate, registrationDate, windowDays);
  }).length;
};

  // Level commissions - Only distribute to ACTIVE and NOT BLOCKED uplines (max 5 levels)
  const distributeLevelIncome = async (buyerSponsorId, buyerName, buyerPackageInfo, totalAmount, transactionId, packageSequence, maxLevels = 5) => {
    try {
      const timestamp = new Date().toISOString();
      const uplineChain = await getUplineChain(buyerSponsorId, maxLevels);
      
      console.log(`Distributing commissions for ${buyerName} to ${uplineChain.length} uplines (max ${maxLevels} levels)`);
      
      // Distribute Level commissions from investment
      for (const upline of uplineChain) {
        if (upline.level > maxLevels) break;
        
        // Check if upline is active
        if (!upline.isActive) {
          console.log(`⏭️ Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} is inactive`);
          continue; // Skip inactive uplines
        }
        
        // Check if upline is blocked
        if (upline.isBlocked) {
          console.log(`🚫 Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} is blocked`);
          continue; // Skip blocked uplines
        }
        
        // Check if upline is specifically blocked from level income
        if (upline.isLevelIncomeBlocked) {
          console.log(`🚫 Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} has level income blocked`);
          continue;
        }
        
        // Check if upline is login blocked
        if (upline.isLoginBlocked) {
          console.log(`🚫 Skipping Level ${upline.level} commission - Upline ${upline.user.sponsorId} is login blocked`);
          continue;
        }
        
        // Get commission percentages from UPLINE'S active package
        const uplineCommissionLevels = await getUplineCommissionPercentages(upline.dbKey, upline.registrationDate);
        const commissionPercent = uplineCommissionLevels[upline.level - 1] || 0;
        
        if (commissionPercent > 0) {
          const commissionAmount = (totalAmount * commissionPercent) / 100;
          
          if (commissionAmount > 0) {
            // Add to upline's working wallet with date-wise structure
            const currentWorking = parseFloat(upline.user.wallets?.working) || 0;
            const newWorking = currentWorking + commissionAmount;
            
            const uplineRef = ref(database, `users/${upline.registrationDate}/${upline.dbKey}`);
            await update(uplineRef, {
              'wallets/working': newWorking,
              totalEarnings: (parseFloat(upline.user.totalEarnings) || 0) + commissionAmount,
              updatedAt: timestamp
            });
            
            // Record the level income with date-wise structure
            const levelIncomeId = `${transactionId}_L${upline.level}`;
            const incomeDate = new Date().toISOString().split('T')[0];
            const userLevelIncomeRef = ref(database, `levelIncomes/${incomeDate}/${upline.dbKey}/${levelIncomeId}`);
            
            await set(userLevelIncomeRef, {
              incomeId: levelIncomeId,
              userId: upline.user.sponsorId,
              userName: upline.user.name || 'Unknown',
              sponsorId: upline.user.sponsorId,
              fromUserId: buyerSponsorId,
              fromUserName: buyerName,
              type: 'level_income',
              level: upline.level,
              amount: commissionAmount,
              percentage: commissionPercent,
              packageAmount: totalAmount,
              fromPackageName: buyerPackageInfo.name,
              fromPackageCommission: buyerPackageInfo.referralLevels || [0, 0, 0, 0, 0],
              uplinePackageCommission: uplineCommissionLevels,
              date: timestamp,
              status: 'credited',
              description: `Level ${upline.level} commission (${commissionPercent}%) from ${buyerName}'s ${buyerPackageInfo.name} purchase.`,
              transactionId: transactionId,
              source: 'package_investment',
              isRecurring: false,
              packageSequence: packageSequence,
              isDirect: upline.level === 1,
              note: 'Commission credited because upline is active and not blocked',
              uplineStatus: 'active',
              maxLevelsApplied: maxLevels,
              blockCheck: {
                isBlocked: false,
                levelIncomeBlocked: false,
                loginBlocked: false,
                roiBlocked: upline.isROIBlocked
              }
            });
            
            console.log(`✅ Level ${upline.level} commission distributed: $${commissionAmount.toFixed(2)} to ${upline.user.sponsorId}`);
          }
        }
      }
      
      return true;
    } catch (error) {
      console.error('Error distributing level income:', error);
      throw error;
    }
  };
// In ActivatePackage.js - Fix the scheduleDailyROI function

// ROI Schedule with date-wise structure - FIXED FOR CORRECT MIDNIGHT CREDIT
const scheduleDailyROI = async (targetUser, packageData, investmentAmount, transactionId, packageSequence, targetRegistrationDate) => {
  try {
    const scheduleId = `${transactionId}_ROI`;
    const purchaseDate = new Date();
    const australiaNowParts = getAustraliaDateParts(purchaseDate);
    const australiaTodayKey = getDateKeyFromParts(australiaNowParts);
    
    // Get complete block status for target user
    const blockStatus = await getCompleteBlockStatus(targetUser.userId, targetRegistrationDate, targetUser.dbKey);
    
    // Check if user is ROI blocked
    const isROIBlocked = blockStatus.roiStatus === 'blocked' || 
                        blockStatus.packageRoiStatus === 'blocked' || 
                        blockStatus.roiScheduleBlocked ||
                        blockStatus.loginStatus === 'blocked';

    // Create date-wise ROI structure
    const todayDate = australiaTodayKey;
    const roiRef = ref(database, `ROISchedule/${todayDate}/${targetUser.userId}/${scheduleId}`);
    
    const startDate = purchaseDate.toISOString();
    const endDate = new Date(purchaseDate.getTime() + (packageData.durationDays * 24 * 60 * 60 * 1000)).toISOString();
    
    // Calculate daily ROI amount
    const dailyROIAmount = (investmentAmount * parseFloat(packageData.dailyRoi)) / 100;
    
    console.log(`📊 ROI Calculation for ${targetUser.userName}:`);
    console.log(`   Investment: $${investmentAmount}`);
    console.log(`   Daily ROI %: ${packageData.dailyRoi}%`);
    console.log(`   Daily ROI Amount: $${dailyROIAmount}`);
    console.log(`   Purchase Time (Dubai): ${purchaseDate.toLocaleString('en-AU', { timeZone: AUSTRALIA_TIMEZONE })}`);

    // Cutoff behavior:
    // - If purchased before Dubai 12:00 AM boundary in user's local equivalent (e.g. 7:30 PM IST),
    //   credit at the immediate Dubai midnight.
    // - If purchased after that boundary, credit next Dubai midnight.
    let firstRoiDateKey = australiaTodayKey;
    if (australiaNowParts.hour > 0 || australiaNowParts.minute > 0 || australiaNowParts.second > 0) {
      firstRoiDateKey = addDaysToDateKey(firstRoiDateKey, 1);
      console.log(`   ⏰ Purchased at ${australiaNowParts.hour}:${String(australiaNowParts.minute).padStart(2, "0")} Dubai time, first ROI next Dubai midnight`);
    } else {
      console.log("   ⏰ Purchased exactly at Dubai midnight, first ROI today at midnight");
    }

    const workingDaysPattern = normalizeWorkingDaysPattern(packageData.workingDays || 'Mon-Fri');
    if (!isWorkingDay(workingDaysPattern, firstRoiDateKey)) {
      const originalDateKey = firstRoiDateKey;
      firstRoiDateKey = getNextWorkingDayKey(workingDaysPattern, addDaysToDateKey(firstRoiDateKey, -1));
      console.log(`   📅 ${originalDateKey} is not a working day, moved to ${firstRoiDateKey}`);
    }
    const firstRoiDateIso = dateKeyToAESTMidnightIso(firstRoiDateKey);
    console.log(`   ✅ First ROI Date Key: ${firstRoiDateKey} (12:00 AM Dubai time)`);
    
    // Get upline chain for energy wallet
    const uplineChain = await getUplineChain(targetUser.sponsorId, 1);
    const directUpline = uplineChain.find(u => u.level === 1);
    
    // Calculate energy wallet
    let energyWalletInfo = null;
    if (directUpline && directUpline.isActive && !directUpline.isBlocked && !directUpline.isLevelIncomeBlocked && !directUpline.isLoginBlocked) {
      const energyPercent = packageData.energyWallet || 4;
      const dailyEnergyAmount = (dailyROIAmount * energyPercent) / 100;
      
      // Calculate first energy date (same logic as ROI)
      let firstEnergyDateKey = australiaTodayKey;
      if (australiaNowParts.hour > 0 || australiaNowParts.minute > 0 || australiaNowParts.second > 0) {
        firstEnergyDateKey = addDaysToDateKey(firstEnergyDateKey, 1);
      }
      if (!isWorkingDay(workingDaysPattern, firstEnergyDateKey)) {
        firstEnergyDateKey = getNextWorkingDayKey(workingDaysPattern, addDaysToDateKey(firstEnergyDateKey, -1));
      }
      
      energyWalletInfo = {
        uplineUserId: directUpline.user.sponsorId,
        uplineUserName: directUpline.user.name || 'Unknown',
        uplineSponsorId: directUpline.user.sponsorId,
        uplineDbKey: directUpline.dbKey,
        uplineRegistrationDate: directUpline.registrationDate,
        energyPercentage: energyPercent,
        dailyEnergyAmount: dailyEnergyAmount,
        energyCredited: 0,
        totalEnergyReceived: 0,
        lastEnergyCredit: null,
        nextEnergyCredit: dateKeyToAESTMidnightIso(firstEnergyDateKey),
        nextEnergyCreditKey: firstEnergyDateKey,
        isActive: true,
        requiresWorkingDay: true,
        workingDaysPattern: workingDaysPattern,
        note: 'Active upline receives energy wallet at midnight Dubai time',
        creditTime: '12:00 AM GST'
      };
    }
    
    const roiScheduleData = {
      scheduleId: scheduleId,
      userId: targetUser.userId,
      sponsorId: targetUser.sponsorId,
      userName: targetUser.userName,
      packageName: packageData.name,
      packageId: packageData.id,
      investmentAmount: investmentAmount,
      totalAmount: investmentAmount,
      dailyROI: parseFloat(packageData.dailyRoi) || 0,
      dailyROIAmount: dailyROIAmount,
      roiCreditDays: 1, // Daily
      roiCreditTime: '12:00 AM',
      startDate: startDate,
      endDate: endDate,
      status: isROIBlocked ? 'blocked' : 'active',
      roiStatus: isROIBlocked ? 'blocked' : 'active',
      blockStatus: {
        userROIBlocked: blockStatus.roiStatus === 'blocked',
        packageROIBlocked: blockStatus.packageRoiStatus === 'blocked',
        roiScheduleBlocked: blockStatus.roiScheduleBlocked,
        loginBlocked: blockStatus.loginStatus === 'blocked',
        isROIBlocked: isROIBlocked,
        blockReasons: blockStatus.blockReasons
      },
      nextRoiDate: firstRoiDateIso,
      nextRoiDateKey: firstRoiDateKey,
      workingDays: packageData.workingDays || 'Mon-Fri',
      transactionId: transactionId,
      createdAt: startDate,
      directUplineId: userUplineId,
      roiCredited: 0,
      totalROIEarned: 0,
      totalExpectedROI: dailyROIAmount * (packageData.durationDays || 365),
      packageSequence: packageSequence,
      lastRoiDistribution: null,
      energyWalletInfo: energyWalletInfo,
      energyCredited: 0,
      totalEnergyExpected: 0,
      purchaseTimestamp: purchaseDate.toISOString(),
      purchaseTimeAustralia: purchaseDate.toLocaleString('en-AU', { timeZone: AUSTRALIA_TIMEZONE }),
      purchaseHourAustralia: australiaNowParts.hour,
      purchaseMinuteAustralia: australiaNowParts.minute,
      nextWorkingDayCalculation: packageData.workingDays || 'Mon-Fri',
      targetRegistrationDate: targetRegistrationDate,
      buyerSponsorId: userSponsorId,
      note: isROIBlocked ? 'ROI blocked by admin' : 'ROI credits at midnight Dubai time',
      calculationNote: `ROI: $${investmentAmount} × ${packageData.dailyRoi}% = $${dailyROIAmount}/day at midnight GST`,
      isMidnightCredit: true,
      creditTimeDescription: 'Credits exactly at 12:00 AM Dubai time daily',
      purchaseTimeDescription: `Purchased at ${australiaNowParts.hour}:${String(australiaNowParts.minute).padStart(2, "0")} Dubai time`,
      firstRoiDescription: `First ROI at midnight on ${firstRoiDateKey} (Dubai)`
    };
    
    await set(roiRef, roiScheduleData);
    
    console.log(`✅ ROI SCHEDULE CREATED for ${targetUser.userName}:`);
    console.log(`   Package: ${packageData.name}`);
    console.log(`   Investment: $${investmentAmount}`);
    console.log(`   Daily ROI: $${dailyROIAmount} (${packageData.dailyRoi}%)`);
    console.log(`   First ROI: ${firstRoiDateKey} 12:00 AM (Dubai)`);
    console.log(`   ⏰ CREDIT TIME: Fixed at 12:00 AM Dubai time daily`);
    
    return {
      success: true,
      dailyROIAmount: dailyROIAmount,
      firstRoiDate: firstRoiDateIso,
      scheduleId: scheduleId,
      isROIBlocked: isROIBlocked,
      blockReasons: isROIBlocked ? blockStatus.blockReasons : []
    };
    
  } catch (error) {
    console.error('❌ Error scheduling ROI:', error);
    throw error;
  }
};

  const calculateExpectedTotalROI = (totalAmount, dailyROIPercent, durationDays, workingDaysPattern) => {
    const normalizedPattern = normalizeWorkingDaysPattern(workingDaysPattern);
    let totalWorkingDays = durationDays;
    
    if (normalizedPattern === 'Mon-Fri') {
      totalWorkingDays = Math.floor(durationDays * (5/7));
    } else if (normalizedPattern === 'Mon-Sat') {
      totalWorkingDays = Math.floor(durationDays * (6/7));
    }
    
    const dailyROI = (totalAmount * dailyROIPercent) / 100;
    return {
      dailyROIAmount: dailyROI,
      totalExpectedROI: dailyROI * totalWorkingDays,
      totalWorkingDays: totalWorkingDays
    };
  };

  const handlePurchase = async () => {
    if (!confirmData || isProcessing) return;
    
    setIsProcessing(true);

    const { package: pkg, amount: investAmount, totalPackageValue, 
            targetUserName, targetUserId, isForDownline, dailyROIAmount, packageSequence,
            energyPercent, dailyEnergyAmount, targetRegistrationDate } = confirmData;

    try {
      let targetUser = {
        dbKey: userDbKey,
        userId: userId,
        userName: userName,
        sponsorId: userSponsorId,
        registrationDate: userRegistrationDate
      };

      if (isForDownline && selectedDownline) {
        const downline = downlineList.find(r => r.userId === targetUserId);
        if (downline) {
          targetUser = {
            dbKey: downline.dbKey,
            userId: downline.userId,
            userName: downline.name,
            sponsorId: downline.sponsorId,
            registrationDate: downline.registrationDate || '2026-02-06'
          };
        }
      }

      const timestamp = new Date().toISOString();
      const transactionId = `PKG${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

      console.log(`🛒 Purchase started for ${targetUser.userName}:`);
      console.log(`   Package: ${pkg.name}`);
      console.log(`   Amount: $${investAmount}`);
      console.log(`   ROI %: ${pkg.dailyRoi}%`);
      console.log(`   Expected Daily ROI: $${dailyROIAmount}`);

      // CRITICAL: Check if buyer can purchase (especially important for downline activation)
      const buyerCheck = await canUserPurchase(userId, isForDownline);
      if (!buyerCheck.canPurchase) {
        showError(buyerCheck.reason);
        setIsProcessing(false);
        return;
      }

      // CRITICAL: If buying for downline, double-check downline activation status
      if (isForDownline) {
        // Check again from Firebase to ensure real-time status
        const usersRef = ref(database, 'users');
        const snapshot = await get(usersRef);
        
        if (snapshot.exists()) {
          const usersByDate = snapshot.val();
          let buyerData = null;
          
          // Find buyer in date-wise structure
          for (const date in usersByDate) {
            const users = usersByDate[date];
            for (const [key, user] of Object.entries(users)) {
              if (user.sponsorId === userId) {
                buyerData = user;
                break;
              }
            }
            if (buyerData) break;
          }
          
          // CRITICAL: Final check - if downline activation is disabled, block purchase
          if (buyerData && buyerData.downlineActivationStatus === 'disabled') {
            showError('Your downline activation privileges have been BLOCKED by admin. You cannot purchase packages for downlines.');
            setIsProcessing(false);
            return;
          }
        }
      }

      // CRITICAL: Check if target user can receive package
      if (isForDownline && targetUserId !== userId) {
        const targetCheck = await canUserReceivePackage(targetUserId);
        if (!targetCheck.canReceive) {
          showError(targetCheck.reason);
          setIsProcessing(false);
          return;
        }
      }

      // Deduct from buyer's wallet with date-wise structure
      const buyerRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
      const buyerSnapshot = await get(buyerRef);
      const buyerData = buyerSnapshot.val();
      
      const updateData = {
        updatedAt: timestamp
      };
      
      if (selectedWallet === 'aurum') {
        const newBalance = (parseFloat(buyerData.wallets?.aurum) || 0) - investAmount;
        updateData['wallets/aurum'] = newBalance;
        console.log(`💰 Deducted $${investAmount} from aurum wallet. New balance: $${newBalance}`);
      } else if (selectedWallet === 'fund') {
        const newBalance = (parseFloat(buyerData.fund?.balance) || 0) - investAmount;
        updateData['fund/balance'] = newBalance;
        console.log(`💰 Deducted $${investAmount} from fund wallet. New balance: $${newBalance}`);
      }
      
      await update(buyerRef, updateData);

      // Add package to target user with date-wise structure
      const targetRef = ref(database, `users/${targetUser.registrationDate}/${targetUser.dbKey}`);
      const targetSnapshot = await get(targetRef);
      const targetData = targetSnapshot.val() || {};

      // Calculate expected total ROI
      const expectedROI = calculateExpectedTotalROI(
        investAmount,
        parseFloat(pkg.dailyRoi),
        pkg.durationDays || 365,
        pkg.workingDays || 'Mon-Fri'
      );

      // Get upline chain to check direct upline status
      const uplineChain = await getUplineChain(targetUser.sponsorId, 1);
      const directUpline = uplineChain.find(u => u.level === 1);
      const isDirectUplineActive = directUpline ? directUpline.isActive : false;
      const isDirectUplineBlocked = directUpline ? directUpline.isBlocked : false;
      const isDirectUplineLevelIncomeBlocked = directUpline ? directUpline.isLevelIncomeBlocked : false;

      const packageEntry = {
        packageId: pkg.id,
        packageName: pkg.name,
        investmentAmount: investAmount,
        totalAmount: investAmount,
        dailyROI: parseFloat(pkg.dailyRoi) || 0,
        dailyROIAmount: dailyROIAmount,
        expectedTotalROI: expectedROI.totalExpectedROI,
        roiCreditDays: parseInt(pkg.roiCreditDays) || 5,
        workingDays: pkg.workingDays || 'Mon-Fri',
        purchaseDate: timestamp,
        expiryDate: new Date(Date.now() + ((pkg.durationDays || 365) * 24 * 60 * 60 * 1000)).toISOString(),
        status: 'active',
        purchasedBy: isForDownline ? userId : 'self',
        transactionId: transactionId,
        packageSequence: packageSequence,
        durationDays: pkg.durationDays || 365,
        directUplineId: userUplineId,
        roiCredited: 0,
        roiPending: expectedROI.totalExpectedROI,
        referralLevels: pkg.referralLevels || [0, 0, 0, 0, 0],
        energyWalletScheduled: true,
        energyPercentage: energyPercent,
        dailyEnergyAmount: dailyEnergyAmount,
        directUplineActive: isDirectUplineActive,
        directUplineBlocked: isDirectUplineBlocked,
        directUplineLevelIncomeBlocked: isDirectUplineLevelIncomeBlocked,
        purchaseTimestamp: timestamp,
        walletUsed: selectedWallet === 'aurum' ? 'Aerovolt' : 'AV PAY',
        blockCheck: {
          buyerBlocked: false,
          targetBlocked: false,
          directUplineBlocked: isDirectUplineBlocked
        }
      };

      const existingPackages = targetData.packages || [];
      const newPackages = [...existingPackages, packageEntry];
      
      const targetUpdateData = {
        packages: newPackages,
        totalInvestment: (parseFloat(targetData.totalInvestment) || 0) + investAmount,
        status: 'active',
        updatedAt: timestamp
      };

      let activationBonusAwarded = false;
      let activationBonusAmount = 0;
      let activationBonusTransactionId = null;
      let activationBonusPreviousWorking = parseFloat(targetData.wallets?.working) || 0;
      let activationBonusNewWorking = activationBonusPreviousWorking;

      if (
        activationRuleLoaded &&
        activationBonusRule.enabled &&
        !targetData.activationBonus?.awarded &&
        activationBonusRule.bonusAmount > 0
      ) {
        const requiredPackages = parseInt(activationBonusRule.requiredPackages, 10) || 3;
        const windowDays = parseInt(activationBonusRule.windowDays, 10) || 45;
        const eligibleCount = countEligiblePackagesWithinWindow(
          newPackages,
          targetUser.registrationDate,
          windowDays
        );

        if (eligibleCount >= requiredPackages) {
          activationBonusAwarded = true;
          activationBonusAmount = parseFloat(activationBonusRule.bonusAmount) || 0;
          activationBonusTransactionId = `ACT_BONUS_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
          activationBonusNewWorking = activationBonusPreviousWorking + activationBonusAmount;

          targetUpdateData['wallets/working'] = activationBonusNewWorking;
          targetUpdateData.totalEarnings = (parseFloat(targetData.totalEarnings) || 0) + activationBonusAmount;
          targetUpdateData.activationBonus = {
            awarded: true,
            awardedAt: timestamp,
            bonusAmount: activationBonusAmount,
            requiredPackages,
            windowDays,
            wallet: activationBonusRule.wallet || 'working',
            transactionId: activationBonusTransactionId,
            description: `Activated ${requiredPackages} packages within ${windowDays} days`
          };
        }
      }
      
      await update(targetRef, targetUpdateData);
      console.log(`✅ Package added to ${targetUser.userName}'s account`);

      if (activationBonusAwarded) {
        await recordWorkingWalletBonus({
          targetUser,
          bonusAmount: activationBonusAmount,
          previousBalance: activationBonusPreviousWorking,
          newBalance: activationBonusNewWorking,
          transactionId: activationBonusTransactionId,
          description: `Activation bonus: ${activationBonusRule.requiredPackages} packages in ${activationBonusRule.windowDays} days`
        });
      }

      // Distribute Level commissions only to ACTIVE and NOT BLOCKED uplines
      await distributeLevelIncome(targetUser.sponsorId, targetUser.userName, pkg, investAmount, transactionId, packageSequence, 5);

      // Schedule Daily ROI with complete block check
      const roiResult = await scheduleDailyROI(
        targetUser, 
        pkg, 
        investAmount,
        transactionId, 
        packageSequence, 
        targetUser.registrationDate
      );
      
      if (roiResult.isROIBlocked) {
        console.log(`⚠️ ROI scheduled but blocked for ${targetUser.userName}: ${roiResult.blockReasons.join(', ')}`);
      } else {
        console.log(`✅ ROI Schedule created successfully for ${targetUser.userName}`);
      }

      // Update balances and user active package
      await fetchUserBalances(userDbKey, userRegistrationDate);
      if (!isForDownline) {
        await fetchUserActivePackage(userDbKey, userRegistrationDate);
      }
      
      // Refresh fund wallet transactions
      await fetchFundWalletTransactions(userId, userDbKey);

      // Show success notification
      let successMsg = '';
      if (isForDownline) {
        successMsg = `Package successfully gifted to ${targetUserName}! Daily ROI: $${dailyROIAmount}`;
        if (roiResult.isROIBlocked) {
          successMsg += ` (Note: ROI is blocked for this user)`;
        }
      } else {
        successMsg = `Package ${pkg.name} activated successfully! Daily ROI: $${dailyROIAmount}`;
        if (roiResult.isROIBlocked) {
          successMsg += ` (Note: Your ROI is blocked by admin)`;
        }
      }
      if (activationBonusAwarded) {
        successMsg += ` + $${activationBonusAmount.toFixed(2)} Working Wallet bonus`;
      }

      const scratchReward = generateScratchReward();
      setScratchRewardAmount(scratchReward);
      setScratchReferenceId(transactionId);
      setShowScratchDialog(true);
      successMsg += ` + Scratch card unlocked (minimum $${PACKAGE_SCRATCH_MIN_REWARD})`;
      
      showSuccess(successMsg);

      // Reset form
      setSelectedPackage('');
      setAmount('');
      setSelectedDownline('');
      setSelectedDownlineName('');
      setIsBuyingForDownline(false);
      setConfirmData(null);

    } catch (error) {
      console.error('❌ Purchase error:', error);
      showError('Failed to activate package. Please try again.');
    } finally {
      setIsProcessing(false);
      setShowConfirmDialog(false);
    }
  };

  const showConfirmation = async () => {
    if (!selectedPackage || !amount) {
      showError('Please select package and enter amount');
      return;
    }

    const pkg = packages.find(p => p.id === selectedPackage);
    if (!pkg) {
      showError('Invalid package selected');
      return;
    }

    const investAmount = parseFloat(amount);
    
    if (isNaN(investAmount) || investAmount < pkg.minInvestment) {
      showError(`Minimum investment is $${pkg.minInvestment}`);
      return;
    }
    
    if (pkg.maxInvestment !== 'Unlimited' && investAmount > pkg.maxInvestment) {
      showError(`Maximum investment is $${pkg.maxInvestment}`);
      return;
    }
    
    if (investAmount > walletBalances[selectedWallet]) {
      showError(`Insufficient balance in ${selectedWallet === 'aurum' ? 'Aerovolt' : 'AV PAY'} wallet`);
      return;
    }

    let targetUser = {
      dbKey: userDbKey,
      userId: userId,
      userName: userName,
      sponsorId: userSponsorId,
      registrationDate: userRegistrationDate
    };

    if (isBuyingForDownline && selectedDownline) {
      const downline = downlineList.find(r => r.userId === selectedDownline);
      if (downline) {
        targetUser = {
          dbKey: downline.dbKey,
          userId: downline.userId,
          userName: downline.name,
          sponsorId: downline.sponsorId,
          registrationDate: downline.registrationDate || '2026-02-06'
        };
        
        // CRITICAL: Check if downline can receive package
        const targetCheck = await canUserReceivePackage(downline.userId);
        if (!targetCheck.canReceive) {
          showError(targetCheck.reason);
          return;
        }
      } else {
        showError('Selected user not found');
        return;
      }
    } else if (isBuyingForDownline && !selectedDownline) {
      showError('Please select a downline member');
      return;
    }

    // CRITICAL: Check if buyer can purchase
    const buyerCheck = await canUserPurchase(userId, isBuyingForDownline);
    if (!buyerCheck.canPurchase) {
      showError(buyerCheck.reason);
      return;
    }

    const packageSequence = await getPackageSequence(targetUser.dbKey, targetUser.registrationDate);
    const totalPackageValue = investAmount;
    const dailyROIAmount = (totalPackageValue * parseFloat(pkg.dailyRoi)) / 100;

    // Get energy percentage FROM BUYER'S PACKAGE DATA
    const energyPercent = pkg.energyWallet || 4;
    const dailyEnergyAmount = (dailyROIAmount * energyPercent) / 100;

    // Get upline chain to check if direct upline is active and not blocked
    const uplineChain = await getUplineChain(targetUser.sponsorId, 1);
    const directUpline = uplineChain.find(u => u.level === 1);
    const isDirectUplineActive = directUpline ? directUpline.isActive : false;
    const isDirectUplineBlocked = directUpline ? directUpline.isBlocked : false;
    const isDirectUplineLevelIncomeBlocked = directUpline ? directUpline.isLevelIncomeBlocked : false;

    // Get YOUR commission levels (for display)
    const yourCommissionLevels = userActivePackage?.referralLevels || pkg.referralLevels || [0, 0, 0, 0, 0];

    // Get complete block status for target user
    const targetBlockStatus = await getCompleteBlockStatus(targetUser.userId, targetUser.registrationDate, targetUser.dbKey);

    const confirmationData = {
      package: pkg,
      amount: investAmount,
      totalPackageValue,
      dailyROIAmount,
      dailyEnergyAmount,
      energyPercent,
      isForDownline: isBuyingForDownline,
      targetUserName: targetUser.userName,
      targetUserId: targetUser.userId,
      targetRegistrationDate: targetUser.registrationDate,
      packageSequence,
      walletUsed: selectedWallet === 'aurum' ? 'Aerovolt Wallet' : 'AV PAY Wallet',
      packageName: pkg.name,
      yourCommissionLevels: yourCommissionLevels,
      buyerCommissionLevels: pkg.referralLevels || [0, 0, 0, 0, 0],
      isDirectUplineActive: isDirectUplineActive,
      isDirectUplineBlocked: isDirectUplineBlocked,
      isDirectUplineLevelIncomeBlocked: isDirectUplineLevelIncomeBlocked,
      targetBlockStatus: targetBlockStatus
    };

    setConfirmData(confirmationData);
    setShowConfirmDialog(true);
  };

  // Dialog Component
  const Dialog = ({ isOpen, onClose, children, title, showCloseButton = true }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          {(title || showCloseButton) && (
            <div className="flex items-center justify-between p-6 border-b border-gray-800">
              {title && <h3 className="text-xl font-bold text-white">{title}</h3>}
              {showCloseButton && (
                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-white transition-colors"
                  disabled={isProcessing}
                >
                  <X size={24} />
                </button>
              )}
            </div>
          )}
          <div className="p-6">
            {children}
          </div>
        </div>
      </div>
    );
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return dateString;
    }
  };

  // Get status badge
  const getStatusBadge = (status) => {
    if (status === 'completed' || status === 'success') {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded text-xs bg-green-500/20 text-green-400 border border-green-500/30">
          <Check className="h-3 w-3 mr-1" />
          Completed
        </span>
      );
    }
    if (status === 'pending') {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded text-xs bg-yellow-500/20 text-yellow-400 border border-yellow-500/30">
          <Clock className="h-3 w-3 mr-1" />
          Pending
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-2 py-1 rounded text-xs bg-gray-500/20 text-gray-400 border border-gray-500/30">
        {status}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  const selectedPkg = packages.find(p => p.id === selectedPackage);

  // Render downline status badges
  const renderStatusBadges = (downline) => {
    if (!downline) return null;
    
    const badges = [];
    
    if (downline.loginStatus === 'blocked') {
      badges.push({ text: 'Login Blocked', color: 'red' });
    }
    if (downline.downlineActivationStatus === 'disabled') {
      badges.push({ text: 'Downline Activation Blocked', color: 'red' });
    }
    if (downline.roiStatus === 'blocked') {
      badges.push({ text: 'ROI Blocked', color: 'red' });
    }
    if (downline.levelIncomeStatus === 'blocked') {
      badges.push({ text: 'Commission Blocked', color: 'red' });
    }
    if (downline.withdrawalStatus === 'blocked') {
      badges.push({ text: 'Withdrawal Blocked', color: 'orange' });
    }
    if (downline.internalTransferStatus === 'blocked') {
      badges.push({ text: 'Transfer Blocked', color: 'orange' });
    }
    
    if (badges.length === 0) return null;
    
    return (
      <div className="flex flex-wrap gap-1 mt-1">
        {badges.map((badge, index) => (
          <span 
            key={index}
            className={`px-1.5 py-0.5 text-[10px] rounded-full border ${
              badge.color === 'red' 
                ? 'bg-red-500/10 text-red-300 border-red-500/20' 
                : 'bg-orange-500/10 text-orange-300 border-orange-500/20'
            }`}
          >
            {badge.text}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="max-w-7xl mx-auto pt-20 px-3 sm:px-4 pb-8">
      {/* Header Section */}
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">Activate Package</h1>
        <p className="text-gray-400 text-sm">Choose an investment package and start earning daily returns</p>
      </div>

      {/* CRITICAL: Show warning if user is blocked from downline activation */}
      {currentUserBlockStatus.downlineActivationStatus === 'disabled' && (
        <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-xl">
          <div className="flex items-center gap-3">
            <Shield className="text-red-400" size={24} />
            <div>
              <h3 className="text-lg font-bold text-red-400">Downline Activation BLOCKED</h3>
              <p className="text-gray-300 text-sm">
                You have been blocked from activating packages for downline members by the administrator.
                You can still activate packages for yourself only.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Show user's current package info */}
      {userActivePackage && (
        <div className="mb-6 p-4 bg-gradient-to-r from-primary/10 to-blue-500/10 border border-primary/30 rounded-xl">
          <div className="flex items-center gap-3">
            <div className="bg-primary/20 p-2 rounded-lg">
              <Package className="text-primary" size={24} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-primary">Your Active Package</h3>
              <p className="text-white text-sm">{userActivePackage.packageName}</p>
              <div className="flex flex-wrap gap-3 mt-2 text-xs">
                <span className="text-gray-300">Commission: <span className="text-green-400">{userActivePackage.referralLevels?.join('/')}%</span></span>
                <span className="text-gray-300">Energy: <span className="text-yellow-400">{userActivePackage.energyPercentage || 4}%</span></span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Notification */}
      {showSuccessNotification && (
        <div className="fixed right-4 top-24 z-50 animate-slide-in-right">
          <div className="bg-gradient-to-r from-green-500/20 to-green-600/20 backdrop-blur-sm border border-green-500/30 rounded-xl p-4 shadow-2xl max-w-sm">
            <div className="flex items-center gap-3">
              <div className="bg-green-500/20 p-2 rounded-full">
                <Check className="text-green-400" size={20} />
              </div>
              <div className="flex-1">
                <h4 className="font-bold text-green-400">Success!</h4>
                <p className="text-white text-sm">{successMessage}</p>
              </div>
              <button
                onClick={() => setShowSuccessNotification(false)}
                className="text-gray-400 hover:text-white"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Buy for Downline Toggle - DISABLE if downline activation is blocked */}
      <div className="mb-8 bg-gray-800/50 border border-gray-700 rounded-xl p-4">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="bg-primary/10 p-2 rounded-lg">
              <Users className="text-primary" size={24} />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">Buy for Downline</h2>
              <p className="text-xs sm:text-sm text-gray-400">Purchase package for any downline member (up to 10 levels deep)</p>
            </div>
          </div>
          {currentUserBlockStatus.downlineActivationStatus === 'disabled' ? (
            <div className="px-4 py-2 bg-gray-700 rounded-full text-red-400 font-bold text-sm border border-red-500/30 text-center">
              BLOCKED BY ADMIN
            </div>
          ) : (
            <button
              onClick={() => setIsBuyingForDownline(!isBuyingForDownline)}
              className={`relative inline-flex items-center h-10 rounded-full w-20 transition-colors ${isBuyingForDownline ? 'bg-primary' : 'bg-gray-700'}`}
              disabled={currentUserBlockStatus.downlineActivationStatus === 'disabled'}
            >
              <span className={`inline-block w-8 h-8 transform bg-white rounded-full transition-transform ${isBuyingForDownline ? 'translate-x-11' : 'translate-x-1'}`} />
            </button>
          )}
        </div>

        {isBuyingForDownline && (
          <div className="mt-4 pt-4 border-t border-gray-700">
            <h3 className="text-md font-bold text-primary mb-3">Select Downline Member</h3>
            
            <div className="mb-4">
              <button
                onClick={() => setShowDownlineSearch(!showDownlineSearch)}
                className="px-4 py-2 bg-gray-700 rounded-lg text-white hover:bg-gray-600 flex items-center gap-2 text-sm"
              >
                <Search size={16} />
                {showDownlineSearch ? 'Hide Search' : 'Search by User ID'}
              </button>
              
              {showDownlineSearch && (
                <div className="mt-3 flex flex-col sm:flex-row gap-2">
                  <input
                    type="text"
                    value={searchDownlineId}
                    onChange={(e) => setSearchDownlineId(e.target.value)}
                    placeholder="Enter User ID"
                    className="flex-1 bg-gray-900 border border-primary/50 rounded-lg px-4 py-2 text-white text-sm"
                  />
                  <button
                    onClick={searchDownline}
                    className="px-4 py-2 bg-primary rounded-lg text-white hover:bg-primary/80 text-sm"
                  >
                    Search
                  </button>
                </div>
              )}
            </div>

            {downlineList.length > 0 ? (
              <div>
                <div className="mb-2 text-xs text-gray-400">
                  Found {downlineList.length} downlines (up to 10 levels)
                  <span className="ml-2 text-red-400">
                    {downlineList.filter(d => !d.canReceivePackage).length} cannot receive packages
                  </span>
                </div>
                <select
                  value={selectedDownline}
                  onChange={(e) => {
                    const selected = downlineList.find(r => r.userId === e.target.value);
                    setSelectedDownline(e.target.value);
                    setSelectedDownlineName(selected?.name || '');
                  }}
                  className="w-full bg-gray-900 border border-primary/50 rounded-lg px-4 py-3 text-white text-sm mb-3"
                >
                  <option value="" className="text-gray-400">Select downline member...</option>
                  {downlineList.map(r => (
                    <option 
                      key={r.userId} 
                      value={r.userId} 
                      className={`${!r.canReceivePackage ? 'text-red-400' : 'text-white'}`}
                      disabled={!r.canReceivePackage}
                    >
                      {r.name} ({r.levelLabel}) - ID: {r.sponsorId}
                      {!r.canReceivePackage && ' [CANNOT RECEIVE]'}
                    </option>
                  ))}
                </select>
                {selectedDownline && (() => {
                  const downline = downlineList.find(r => r.userId === selectedDownline);
                  if (!downline) return null;
                  
                  return (
                    <div className="p-3 bg-gray-900/50 rounded-lg">
                      <p className={`text-sm ${!downline.canReceivePackage ? 'text-red-400' : 'text-green-400'}`}>
                        Selected: <span className="font-bold">{downline.name}</span>
                        {!downline.canReceivePackage && ' (CANNOT RECEIVE PACKAGES)'}
                      </p>
                      {downline.blockReasons && downline.blockReasons.length > 0 && (
                        <div className="mt-2">
                          <p className="text-xs text-red-300">Block Reasons:</p>
                          <ul className="text-xs text-gray-400 mt-1">
                            {downline.blockReasons.map((reason, idx) => (
                              <li key={idx}>• {reason}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {renderStatusBadges(downline)}
                    </div>
                  );
                })()}
              </div>
            ) : (
              <p className="text-center text-gray-400 py-4 text-sm">No downline members found</p>
            )}
          </div>
        )}
      </div>

      {/* Wallet Selection */}
      <div className="mb-8">
        <h2 className="text-lg font-bold text-white mb-3">Select Wallet</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Aerovolt Wallet */}
          <div 
            onClick={() => setSelectedWallet('aurum')}
            className={`p-4 rounded-xl border-2 cursor-pointer transition-all ${
              selectedWallet === 'aurum' 
                ? 'border-primary bg-primary/10' 
                : 'border-gray-700 bg-gray-800/50 hover:bg-gray-700/50'
            }`}
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="bg-primary/20 p-2 rounded-lg">
                  <Gem className="text-primary" size={20} />
                </div>
                <span className="font-bold text-white">Aerovolt</span>
              </div>
              {selectedWallet === 'aurum' && <Check className="text-green-400" size={18} />}
            </div>
            <div className="text-2xl font-bold text-white">${walletBalances.aurum.toFixed(2)}</div>
            <div className="text-xs text-gray-400 mt-1">Investment wallet</div>
          </div>

          {/* AV PAY Wallet */}
          <div 
            onClick={() => setSelectedWallet('fund')}
            className={`p-4 rounded-xl border-2 cursor-pointer transition-all ${
              selectedWallet === 'fund' 
                ? 'border-green-500 bg-green-500/10' 
                : 'border-gray-700 bg-gray-800/50 hover:bg-gray-700/50'
            }`}
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="bg-green-500/20 p-2 rounded-lg">
                  <CreditCard className="text-green-400" size={20} />
                </div>
                <span className="font-bold text-white">AV PAY</span>
              </div>
              {selectedWallet === 'fund' && <Check className="text-green-400" size={18} />}
            </div>
            <div className="text-2xl font-bold text-white">${walletBalances.fund.toFixed(2)}</div>
            <div className="text-xs text-gray-400 mt-1">Deposit wallet</div>
          </div>
        </div>
      </div>

      {/* AV PAY Wallet Transactions History */}
      {/* <div className="mb-8 bg-gray-800/50 border border-gray-700 rounded-xl p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <History className="text-green-400" size={20} />
            <h2 className="text-lg font-bold text-white">AV PAY History</h2>
          </div>
          <button
            onClick={() => setShowFundHistory(!showFundHistory)}
            className="px-3 py-1.5 bg-gray-700 hover:bg-gray-600 rounded-lg text-white text-sm flex items-center gap-1"
          >
            {showFundHistory ? 'Hide' : 'Show'}
            <Clock size={14} />
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
          <div className="bg-gray-900/50 p-2 rounded-lg">
            <div className="text-gray-400 text-xs">Total Added</div>
            <div className="text-sm font-bold text-green-400">{formatCurrency(fundStats.totalAdded)}</div>
          </div>
          <div className="bg-gray-900/50 p-2 rounded-lg">
            <div className="text-gray-400 text-xs">Pending</div>
            <div className="text-sm font-bold text-yellow-400">{formatCurrency(fundStats.totalPending)}</div>
          </div>
          <div className="bg-gray-900/50 p-2 rounded-lg">
            <div className="text-gray-400 text-xs">Completed</div>
            <div className="text-sm font-bold text-blue-400">{fundStats.count}</div>
          </div>
          <div className="bg-gray-900/50 p-2 rounded-lg">
            <div className="text-gray-400 text-xs">Pending</div>
            <div className="text-sm font-bold text-yellow-400">{fundStats.pendingCount}</div>
          </div>
        </div>

        {showFundHistory && (
          <div className="mt-4">
            {loadingTransactions ? (
              <div className="flex justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-green-400"></div>
              </div>
            ) : fundTransactions.length > 0 ? (
              <div className="space-y-3 max-h-80 overflow-y-auto pr-2">
                {fundTransactions.map((tx) => (
                  <div 
                    key={tx.id} 
                    className={`p-3 bg-gray-900/50 rounded-lg border-l-4 ${
                      tx.isCompleted ? 'border-green-500' : 'border-yellow-500'
                    }`}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className={`text-base font-bold ${
                            tx.isCompleted ? 'text-green-400' : 'text-yellow-400'
                          }`}>
                            {formatCurrency(tx.amount)}
                          </span>
                          {getStatusBadge(tx.status)}
                        </div>
                        <p className="text-gray-300 text-xs mb-1">{tx.description}</p>
                        <div className="flex flex-wrap items-center gap-2 text-xs text-gray-400">
                          <span className="flex items-center gap-1">
                            <Calendar size={10} />
                            {formatDate(tx.timestamp)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-6 text-gray-400 text-sm">
                No AV PAY wallet transactions found
              </div>
            )}
          </div>
        )}
      </div> */}

      {activationRuleLoaded && activationBonusRule.enabled && (
        <div className="mb-6 p-4 bg-gradient-to-r from-emerald-500/10 to-blue-500/10 border border-emerald-500/30 rounded-xl">
          <div className="flex items-center gap-3">
            <Gift className="text-emerald-400" size={20} />
            <div>
              <h3 className="text-white font-bold text-base">Activation Bonus</h3>
              <p className="text-xs sm:text-sm text-gray-200">
                Activate any <span className="font-semibold text-emerald-300">{activationBonusRule.requiredPackages} packages</span> in{' '}
                <span className="font-semibold text-emerald-300">{activationBonusRule.windowDays} days</span>{' '}
                and get <span className="font-bold text-emerald-400">${activationBonusRule.bonusAmount}</span> added to your AV Power Wallet.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Package Selection Dropdown */}
      <div className="mb-6">
        <label className="block text-white text-sm mb-2">Select Package</label>
        <div className="relative">
          <select
            value={selectedPackage}
            onChange={(e) => {
              setSelectedPackage(e.target.value);
              if (e.target.value) {
                const pkg = packages.find(p => p.id === e.target.value);
                if (pkg) {
                  setAmount(pkg.minInvestment.toString());
                }
              }
            }}
            className="w-full bg-gray-900 border border-primary/50 rounded-lg px-4 py-3 text-white appearance-none cursor-pointer"
          >
            <option value="" className="text-gray-400">Choose a package...</option>
            {packages.map(pkg => (
              <option key={pkg.id} value={pkg.id} className="text-white">
                {pkg.name} - ${pkg.minInvestment} to {pkg.maxInvestment === 'Unlimited' ? 'Unlimited' : `$${pkg.maxInvestment}`}
              </option>
            ))}
          </select>
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <ChevronDown className="text-primary" size={20} />
          </div>
        </div>
      </div>

      {/* Selected Package Card - Only shown when package is selected */}
      {selectedPkg && (
        <div className="mb-8">
          <h2 className="text-lg font-bold text-white mb-3">Selected Package Details</h2>
          <div className="relative overflow-hidden rounded-xl border-2 border-primary bg-gradient-to-br from-primary/20 to-primary/5">
            {/* Package Header */}
            <div className="p-4">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="bg-primary/20 p-3 rounded-lg">
                    {selectedPkg.name.includes('Gold') ? (
                      <Award className="text-yellow-400" size={28} />
                    ) : selectedPkg.name.includes('Silver') ? (
                      <Star className="text-gray-300" size={28} />
                    ) : selectedPkg.name.includes('Platinum') ? (
                      <Trophy className="text-purple-400" size={28} />
                    ) : selectedPkg.name.includes('Basic') ? (
                      <Package className="text-blue-400" size={28} />
                    ) : (
                      <Zap className="text-yellow-400" size={28} />
                    )}
                  </div>
                  <div>
                    <span className="text-2xl font-bold text-white">{selectedPkg.name}</span>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs bg-green-500/20 text-green-400 px-2 py-0.5 rounded-full">
                        Active Package
                      </span>
                      <span className="text-xs bg-blue-500/20 text-blue-400 px-2 py-0.5 rounded-full">
                        ID: {selectedPkg.id}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="bg-primary/20 p-2 rounded-lg">
                  <Check className="text-primary" size={24} />
                </div>
              </div>

              {/* Package Details Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                {/* Left Column - Investment & ROI */}
                <div className="space-y-3">
                  <div className="bg-gray-900/50 p-3 rounded-lg">
                    <div className="text-xs text-gray-400 mb-1">Investment Range</div>
                    <div className="text-xl font-bold text-white">
                      ${selectedPkg.minInvestment} - {selectedPkg.maxInvestment === 'Unlimited' ? '∞' : `$${selectedPkg.maxInvestment}`}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <div className="bg-gray-900/50 p-3 rounded-lg">
                      <div className="text-xs text-gray-400">Daily ROI</div>
                      <div className="text-lg font-bold text-green-400">{selectedPkg.dailyRoi}%</div>
                    </div>
                    <div className="bg-gray-900/50 p-3 rounded-lg">
                      <div className="text-xs text-gray-400">Energy %</div>
                      <div className="text-lg font-bold text-yellow-400">{selectedPkg.energyWallet || 4}%</div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Commission Levels */}
                <div className="bg-gray-900/50 p-3 rounded-lg">
                  <div className="text-xs text-gray-400 mb-2">Commission Levels (5 Levels)</div>
                  <div className="grid grid-cols-5 gap-1">
                    {selectedPkg.referralLevels?.map((percent, idx) => (
                      <div key={idx} className="text-center">
                        <div className="text-[10px] text-gray-500">L{idx + 1}</div>
                        <div className="text-sm font-bold text-blue-400">{percent}%</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Additional Info */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                <div className="bg-gray-900/30 p-2 rounded-lg">
                  <span className="text-gray-400">Duration:</span>
                  <span className="ml-1 text-white">{selectedPkg.durationDays || 365} days</span>
                </div>
                <div className="bg-gray-900/30 p-2 rounded-lg">
                  <span className="text-gray-400">Working Days:</span>
                  <span className="ml-1 text-white">{selectedPkg.workingDays || 'Mon-Fri'}</span>
                </div>
                <div className="bg-gray-900/30 p-2 rounded-lg">
                  <span className="text-gray-400">ROI Credit:</span>
                  <span className="ml-1 text-white">Daily</span>
                </div>
                <div className="bg-gray-900/30 p-2 rounded-lg">
                  <span className="text-gray-400">Credit Time:</span>
                  <span className="ml-1 text-white">12:00 AM GST</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Investment Input Section - Only shown when package is selected */}
      {selectedPkg && (
        <div className="mb-8 bg-gradient-to-r from-primary/10 to-blue-500/10 border border-primary/30 rounded-xl p-4">
          <h2 className="text-xl font-bold text-white mb-4">Investment Amount</h2>
          
          <div className="mb-4">
            <label className="block text-white text-sm mb-2">Enter Amount ($)</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full bg-gray-900 border border-primary/50 rounded-lg px-4 py-3 text-xl font-bold text-white text-center"
              min={selectedPkg.minInvestment}
              max={selectedPkg.maxInvestment === 'Unlimited' ? undefined : selectedPkg.maxInvestment}
            />
            <div className="flex flex-wrap gap-2 mt-3">
              <button 
                onClick={() => setAmount(selectedPkg.minInvestment.toString())}
                className="px-3 py-1.5 bg-gray-700 rounded-lg text-white text-sm hover:bg-gray-600"
              >
                Min (${selectedPkg.minInvestment})
              </button>
              {selectedPkg.maxInvestment !== 'Unlimited' && (
                <button 
                  onClick={() => setAmount(selectedPkg.maxInvestment.toString())}
                  className="px-3 py-1.5 bg-gray-700 rounded-lg text-white text-sm hover:bg-gray-600"
                >
                  Max (${selectedPkg.maxInvestment})
                </button>
              )}
            </div>
          </div>

          {/* Summary */}
          {amount && !isNaN(parseFloat(amount)) && (
            <div className="bg-gray-900/50 p-3 rounded-lg mb-4">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                <div>
                  <div className="text-xs text-gray-400">Investment</div>
                  <div className="text-sm font-bold text-white">${parseFloat(amount).toFixed(2)}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Daily ROI</div>
                  <div className="text-sm font-bold text-green-400">
                    ${((parseFloat(amount) * parseFloat(selectedPkg.dailyRoi)) / 100).toFixed(2)}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Energy to Upline</div>
                  <div className="text-sm font-bold text-yellow-400">
                    ${(((parseFloat(amount) * parseFloat(selectedPkg.dailyRoi)) / 100) * (selectedPkg.energyWallet || 4) / 100).toFixed(2)}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Wallet</div>
                  <div className="text-sm font-bold text-primary">
                    {selectedWallet === 'aurum' ? 'Aerovolt' : 'AV PAY'}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Action Button */}
          <div className="text-center">
            <button
              onClick={showConfirmation}
              disabled={
                !amount || 
                parseFloat(amount) < selectedPkg.minInvestment || 
                (selectedPkg.maxInvestment !== 'Unlimited' && parseFloat(amount) > selectedPkg.maxInvestment) ||
                parseFloat(amount) > walletBalances[selectedWallet] ||
                (isBuyingForDownline && !selectedDownline) ||
                (isBuyingForDownline && currentUserBlockStatus.downlineActivationStatus === 'disabled')
              }
              className="w-full sm:w-auto px-8 py-3 bg-primary hover:bg-primary/80 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg text-white font-bold transition"
            >
              {isBuyingForDownline ? 'Gift Package' : 'Activate Package'}
            </button>
          </div>
        </div>
      )}

      {showScratchDialog && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[60] p-4">
          <div className="w-full max-w-md rounded-xl border border-yellow-500/40 bg-gradient-to-br from-yellow-900/30 via-[#161E2D] to-emerald-900/30 shadow-2xl">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <Gift className="text-yellow-300" size={22} />
                <h3 className="text-xl font-bold text-white">Package Scratch Card</h3>
              </div>
              <p className="text-gray-200 text-sm mb-4">
                Package activated successfully. Scratch now to get extra fund bonus. Minimum reward: ${PACKAGE_SCRATCH_MIN_REWARD}.
              </p>
              <div className="rounded-lg border border-dashed border-yellow-300/60 bg-black/20 p-5 text-center mb-4">
                <div className="text-xs uppercase tracking-wider text-yellow-200/90 mb-1">Hidden Reward</div>
                <div className="text-2xl font-bold text-yellow-300">$ {scratchRewardAmount.toFixed(2)}</div>
              </div>
              <button
                onClick={handlePackageScratchClaim}
                disabled={scratchLoading}
                className="w-full py-3 rounded-lg bg-yellow-500 hover:bg-yellow-400 text-black font-bold transition disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {scratchLoading ? 'Claiming Reward...' : 'Scratch & Claim Reward'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog */}
      <Dialog 
        isOpen={showConfirmDialog} 
        onClose={() => !isProcessing && setShowConfirmDialog(false)}
        title="Confirm Package Purchase"
      >
        {confirmData && (
          <div className="space-y-4">
            <div className="text-center mb-6">
              <div className="text-4xl font-bold text-primary mb-2">{confirmData.package.name}</div>
              <div className="text-gray-300">Package Details</div>
            </div>
            
            <div className="bg-gray-800/50 rounded-xl p-4">
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-300">For:</span>
                  <span className="text-white font-bold">
                    {confirmData.isForDownline ? confirmData.targetUserName : 'Yourself'}
                  </span>
                </div>
                
                <div className="flex justify-between">
                  <span className="text-gray-300">Investment:</span>
                  <span className="text-white font-bold">${confirmData.amount.toFixed(2)}</span>
                </div>
                
                <div className="flex justify-between border-t border-gray-700 pt-3">
                  <span className="text-gray-300 text-lg">Total Value:</span>
                  <span className="text-2xl text-primary font-bold">${confirmData.totalPackageValue.toFixed(2)}</span>
                </div>
                
                <div className="flex justify-between">
                  <span className="text-gray-300">Daily ROI ({confirmData.package.dailyRoi}%):</span>
                  <span className="text-green-400 font-bold">${confirmData.dailyROIAmount.toFixed(2)}/day</span>
                </div>
                
                <div className="flex justify-between">
                  <span className="text-gray-300">Wallet Used:</span>
                  <span className="text-yellow-400 font-bold">{confirmData.walletUsed}</span>
                </div>
              </div>
            </div>
            
            {/* Commission Calculation */}
            <div className="bg-gray-800/30 rounded-xl p-4">
              <h4 className="text-white font-bold mb-2">Your Commission (If Active & Not Blocked):</h4>
              <div className="grid grid-cols-5 gap-2 text-center">
                {confirmData.yourCommissionLevels?.map((percent, index) => (
                  <div key={index} className="bg-gray-900/50 p-2 rounded">
                    <div className="text-xs text-gray-400">Level {index + 1}</div>
                    <div className="text-green-400 font-bold">{percent}%</div>
                    <div className="text-xs text-white">
                      ${((confirmData.totalPackageValue * percent) / 100).toFixed(2)}
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-xs text-gray-400 mt-2">*Commission checks: Active package + No login block + No level income block</p>
            </div>
            
            {/* Energy Wallet Information */}
            <div className={`p-4 rounded-xl ${
              confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked 
                ? 'bg-blue-500/10 border border-blue-500/30' 
                : 'bg-gray-800/50 border border-gray-700'
            }`}>
              <div className="flex items-center gap-2 mb-2">
                <Battery className={
                  confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked 
                    ? "text-blue-400" 
                    : "text-gray-500"
                } size={20} />
                <h4 className={
                  confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked 
                    ? "text-blue-400 font-bold" 
                    : "text-gray-500 font-bold"
                }>Energy Wallet Bonus</h4>
                {confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked ? (
                  <span className="ml-auto text-xs bg-green-500/20 text-green-400 px-2 py-1 rounded">Active Upline</span>
                ) : confirmData.isDirectUplineBlocked ? (
                  <span className="ml-auto text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded">Blocked Upline</span>
                ) : confirmData.isDirectUplineLevelIncomeBlocked ? (
                  <span className="ml-auto text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded">Commission Blocked</span>
                ) : (
                  <span className="ml-auto text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded">Inactive Upline</span>
                )}
              </div>
              
              {confirmData.isDirectUplineActive && !confirmData.isDirectUplineBlocked && !confirmData.isDirectUplineLevelIncomeBlocked ? (
                <>
                  <p className="text-gray-300 text-sm">
                    Direct upline is <span className="text-green-400 font-bold">ACTIVE & NOT BLOCKED</span> and will receive:
                  </p>
                  <div className="mt-2 p-3 bg-blue-500/20 rounded-lg">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-blue-300">${confirmData.dailyEnergyAmount.toFixed(2)}/day</div>
                      <div className="text-sm text-blue-200">Energy Wallet Credit</div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <p className="text-gray-300 text-sm">
                    Direct upline is {confirmData.isDirectUplineBlocked ? 
                    <span className="text-red-400 font-bold">BLOCKED</span> : 
                    confirmData.isDirectUplineLevelIncomeBlocked ?
                    <span className="text-red-400 font-bold">COMMISSION BLOCKED</span> :
                    <span className="text-red-400 font-bold">INACTIVE</span>} and will <span className="text-red-400 font-bold">NOT</span> receive energy wallet.
                  </p>
                </>
              )}
            </div>
            
            {/* Block Status Summary */}
            <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <Shield className="text-yellow-400" size={20} />
                <h4 className="text-yellow-400 font-bold">Complete Block Check</h4>
              </div>
              
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-gray-300 text-sm">Your Status:</span>
                  {currentUserBlockStatus.downlineActivationStatus === 'disabled' ? (
                    <span className="text-red-400 text-sm font-medium">✗ Downline Activation BLOCKED</span>
                  ) : (
                    <span className="text-green-400 text-sm font-medium">✓ Purchase Allowed</span>
                  )}
                </div>
                
                {confirmData.isForDownline && (
                  <div className="flex items-center justify-between">
                    <span className="text-gray-300 text-sm">Target User:</span>
                    {confirmData.targetBlockStatus.canReceivePackage ? (
                      <span className="text-green-400 text-sm font-medium">✓ Can Receive</span>
                    ) : (
                      <span className="text-red-400 text-sm font-medium">✗ Cannot Receive</span>
                    )}
                  </div>
                )}
                
                <div className="flex items-center justify-between">
                  <span className="text-gray-300 text-sm">Direct Upline:</span>
                  {confirmData.isDirectUplineBlocked ? (
                    <span className="text-red-400 text-sm font-medium">✗ Blocked</span>
                  ) : confirmData.isDirectUplineLevelIncomeBlocked ? (
                    <span className="text-red-400 text-sm font-medium">✗ Commission Blocked</span>
                  ) : confirmData.isDirectUplineActive ? (
                    <span className="text-green-400 text-sm font-medium">✓ Active & Eligible</span>
                  ) : (
                    <span className="text-gray-400 text-sm font-medium">✗ Inactive</span>
                  )}
                </div>
                
                <div className="mt-2 pt-2 border-t border-yellow-500/20">
                  <p className="text-xs text-gray-400">
                    System checks downline activation and login blocks. Blocked users cannot receive packages.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        
        <div className="flex gap-4 mt-8">
          <button
            onClick={() => setShowConfirmDialog(false)}
            disabled={isProcessing}
            className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl text-white font-bold transition-colors"
          >
            Cancel
          </button>
          <div className="flex-1 relative">
            <button
              onClick={handlePurchase}
              disabled={
                isProcessing || 
                (isBuyingForDownline && currentUserBlockStatus.downlineActivationStatus === 'disabled') ||
                (confirmData?.isForDownline && !confirmData?.targetBlockStatus?.canReceivePackage)
              }
              className={`w-full py-3 rounded-xl text-white font-bold transition-colors ${
                isProcessing 
                  ? 'bg-primary/50 cursor-not-allowed' 
                  : 'bg-primary hover:bg-primary/80'
              }`}
            >
              {isProcessing ? 'Processing...' : 'Confirm Purchase'}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Error Dialog */}
      <Dialog 
        isOpen={showErrorDialog} 
        onClose={() => setShowErrorDialog(false)}
        title="Error"
      >
        <div className="text-center">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="text-red-400" size={32} />
          </div>
          <p className="text-white text-lg mb-6">{errorMessage}</p>
          <button
            onClick={() => setShowErrorDialog(false)}
            className="w-full py-3 bg-red-500 hover:bg-red-600 rounded-xl text-white font-bold transition-colors"
          >
            OK
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default ActivatePackage;